import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useLocation, useNavigate, useOutletContext, useSearchParams } from 'react-router-dom';
import {
  useAcc2acc,
  useFileUpload,
  useGetBeneficiar,
  useGetBeneficiarDataLocalTransfer,
  useGetClassification,
  useGetDataTransfer,
  useGetIpsData,
  useGetOrganization,
  useGetSwiftCode,
  useSendTransferType,
} from 'app/utils/services/transferService';
import { useForm } from 'react-hook-form';
import useCurrencySymbol from 'app/utils/customHooks/useCurrencySymbol';
import { yupResolver } from '@hookform/resolvers/yup';
import {
  schemaAcc2Acc,
  schemaBudget,
  schemaConversion,
  schemaEdv,
  schemaForeign,
  schemaInBank,
  schemaLocalTransfer,
} from './schema';
import logger from 'app/utils/logger';
import format from 'date-fns/format';
import { onlyDigit } from 'app/constants/regex';
import { debounce } from 'lodash';
import { useCreateTemplateService, useEditTemplate } from 'app/utils/services/templateService';
import leaveModal from 'app/pages/TransferPage/LeaveModal';

const useTransferPage = () => {
  const [valuePageId, setValuePageId] = useState('payment_acc2acc');
  const [pageName, setPageName] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const dataAccountTo = location?.state?.selectedValue;
  const templateData = location?.state?.templateData;
  const templateId = location?.state?.templateId;
  const formId = location?.state?.formId;
  const lang = location.pathname.substring(0, 3);
  const pathUrl = location.pathname.substring(4);
  const [searchParams] = useSearchParams();
  const pageId = searchParams.get('type');
  const confirm = searchParams.get('confirm');

  const [checkLeave, setCheckLeave] = useState(false);

  const [selectedOptions, setSelectedOptions] = useState<{ value: string; label: string } | null>(null);
  const [saveTemplate, setSaveTemplate] = useState(false);
  const [saveTemplateSuccess, setSaveTemplateSuccess] = useState(false);

  const [fromAccount, setFromAccount] = useState<any>(null);
  const [selectedFromAccount, setSelectedFromAccount] = useState<{
    value: string;
    label: string;
    currency: string;
    balance: string;
  }>();
  const [amountValue, setAmountValue] = useState('');
  const [invoiceValue, setInvoiceValue] = useState('');
  const [ibanField, setIbanField] = useState('');
  const [toAccount, setToAccount] = useState<any>(null);
  const [disabledToAccount, setDisabledToAccount] = useState<any>(true);
  const [selectedToAccount, setSelectedToAccount] = useState<any>(dataAccountTo !== null ? dataAccountTo : null);
  const [selectedFromAccountTrigger, setSelectedFromAccountTrigger] = useState(false);
  const [defaultDesc, setDefaultDesc] = useState('');
  const [commission, setCommission] = useState(null);
  const [commissionOption, setCommissionOption] = useState(null);
  const [openAlertModal, setOpenAlertModal] = useState(false);
  const [fileInBank, setFileInBank] = useState([]);
  const [fileInBankArray, setFileInBankArray] = useState([]);
  const [fileRequiredInBank, setFileRequiredInBank] = useState('false');
  const [contractNumberRequiredInBank, setContractNumberRequiredInBank] = useState('false');
  const [errorFileInBank, setErrorFileInBank] = useState(false);
  const [countryOptions, setCountryOptions] = useState([]);

  const [fileLocalTransfer, setFileLocalTransfer] = useState([]);
  const [customerType, setCustomerType] = useState<{
    value?: string;
    label?: string;
    code?: string;
    type?: any;
    id: any;
  }>();
  const [customerTypeIsRequired, setCustomerTypeIsRequired] = useState(false);
  const [customerTypeVoenIsRequired, setCustomerTypeVoenIsRequired] = useState(false);
  const [selfPayment, setSelfPayment] = useState(false);
  const [ipsIsRequired, setIpsIsRequired] = useState(false);
  const [ipsValueInput, setIpsValueInput] = useState<string>();
  const [bankCodeValueLocal, setBankCodeValueLocal] = useState('');
  const [taxEnabledLocal, setTaxEnabledLocal] = useState(false);
  const [fileRequiredLocal, setFileRequiredLocal] = useState(false);

  const [openBankCodeLocalTransferDialog, setOpenBankCodeLocalTransferDialog] = useState(false);
  const [bankCodeData, setBankCodeData] = useState([]);
  const [isSearchLocalTransfer, setIsSearchLocalTransfer] = useState(false);

  const [budgetLevelCodes, setBudgetLevelCodes] = useState([]);
  const [selectedBudgetLevelCodes, setSelectedBudgetLevelCodes] = useState<{ value?: string; label?: string }>();
  const [openBudgetOrgDialog, setOpenBudgetOrgDialog] = useState(false);
  const [classCodeBudget, setClassCodeBudget] = useState('');

  const [optionsConversion, setOptionsConversion] = useState<any>(null);
  const [fromAccountConversion, setFromAccountConversion] = useState<any>(null);
  const [selectedFromAccountConversion, setSelectedFromAccountConversion] = useState<{
    label: string;
    value: string;
    currency: string;
    balance: string;
  }>();
  const [toAccountConversion, setToAccountConversion] = useState<any>(null);
  const [selectedToAccountConversion, setSelectedToAccountConversion] = useState<any>();
  const [selectedCommissionConversion, setSelectedCommissionConversion] = useState<{
    label: string;
    value: string;
    currency: string;
    balance: string;
  }>();
  const [rates, setRates] = useState<any>(null);
  const [selectedRates, setSelectedRates] = useState();
  const [checkIndividualConversion, setCheckIndividualConversion] = useState(false);

  const [fromAmountConversion, setFromAmountConversion] = useState('');
  const [toAmountConversion, setToAmountConversion] = useState('');

  const [countries, setCountries] = useState<any>(null);
  const [selectedCountries, setSelectedCountries] = useState<{ value: string; label: string; bicCode: string }>();
  const [mediatorBank, setMediatorBank] = useState(false);
  const [avans, setAvans] = useState(false);
  const [fileForeign, setFileForeign] = useState([]);
  const [openSwiftBicCode, setOpenSwiftBicCode] = useState(false);
  const [openMediatorSwiftBicCode, setOpenMediatorSwiftBicCode] = useState(false);
  const [swiftBicCodeForeign, setSwiftCodeForeign] = useState(false);
  const [swiftMediatorBicCodeForeign, setSwiftMediatorCodeForeign] = useState(false);
  const [currencyOfToAccount, setCurrencyOfToAccount] = useState('');
  const [valueTextArea, setValueTextArea] = useState('');
  const [showTemplateBtn, setShowTemplate] = useState(false);

  const [openSnackbar, setOpenSnackBar] = useState(false);

  const { inn, title, signMethod } = useOutletContext<{ inn: any; title: any; signMethod: any }>();

  const {
    isLoadingGetDataTransfer,
    dataGetTransfer,
    refetchGetDataTransfer,
    isLoadingSendTransferTypeFromGetData,
    dataSendTransferTypeFromGetData,
  } = useGetDataTransfer({
    data: { valuePageId },
  });
  const { isLoadingSendTransferType, dataSendTransferType, sendTransferTypeMutation } = useSendTransferType();
  const { isLoadingAcc2acc, dataAcc2acc, acc2accMutation } = useAcc2acc();
  const { isLoadingGetBeneficiar, dataGetBeneficiar, getBeneficiarMutation } = useGetBeneficiar();
  const {
    isLoadingGetBeneficiarDataLocalTransfer,
    getBeneficiarDataLocalTransferMutation,
    dataGetBeneficiarDataLocalTransfer,
  } = useGetBeneficiarDataLocalTransfer();
  const { isLoadingFileUpload, fileUploadMutation, dataFileUpload } = useFileUpload();
  const { isLoadingGetIpsData, getIpsDataMutation, dataGetIpsData } = useGetIpsData();
  const { isLoadingGetOrganization, getOrganizationMutation, dataGetOrganization } = useGetOrganization();
  const { isLoadingGetClassification, getClassificationMutation, dataGetClassification } = useGetClassification();
  const { isLoadingGetSwiftCode, getSwiftCodeMutation, dataSwiftCode } = useGetSwiftCode();
  const { isLoadingCreateTemplate, dataCreateTemplate, createTemplateMutation } = useCreateTemplateService();
  const { isLoadingEditTemplate, dataEditTemplate, editTemplateMutation } = useEditTemplate();

  const onDropInBank = useCallback(
    (acceptedFiles: any, fileRejection: any) => {
      if (fileRejection[0]?.errors[0].code === 'file-too-large') {
        setErrorFileInBank(true);
      } else {
        if (fileInBank.length === 0) {
          setValueInBank('fileInBank', acceptedFiles[0].name);
          setFileInBank(acceptedFiles);
        } else {
          setValueInBank('fileInBank', acceptedFiles[0].name);
          setFileInBank([...fileInBank.concat(acceptedFiles)]);
        }
        // Do something with the files

        setErrorFileInBank(false);
        triggerInBank('fileInBank');
        const formData = new FormData();

        formData.append('inputfile', acceptedFiles[0]);
        fileUploadMutation({
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data',
            Accept: undefined,
            'Accept-Language': undefined,
            'Accept-Encoding': undefined,
          },
        });
      }
    },
    [fileInBank]
  );

  const onDropLocalTransfer = useCallback(
    (acceptedFiles: any, fileRejection: any) => {
      if (fileRejection[0]?.errors[0].code === 'file-too-large') {
        setErrorFileInBank(true);
      } else {
        if (fileInBank.length === 0) {
          setValueLocalTransfer('fileInBank', acceptedFiles[0].name);
          setFileInBank(acceptedFiles);
        } else {
          setValueLocalTransfer('fileInBank', acceptedFiles[0].name);
          setFileInBank([...fileInBank.concat(acceptedFiles)]);
        }
        // Do something with the files

        setErrorFileInBank(false);
        triggerLocalTransfer('fileInBank');
        const formData = new FormData();

        formData.append('inputfile', acceptedFiles[0]);
        fileUploadMutation({
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data',
            Accept: undefined,
            'Accept-Language': undefined,
            'Accept-Encoding': undefined,
          },
        });
      }
    },
    [fileInBank]
  );

  const onDropForeignTransfer = useCallback(
    (acceptedFiles: any, fileRejection: any) => {
      if (fileRejection[0]?.errors[0].code === 'file-too-large') {
        setErrorFileInBank(true);
      } else {
        if (fileInBank.length === 0) {
          setFileInBank(acceptedFiles);
          setValueForeign('fileInBank', acceptedFiles[0].name);
        } else {
          setFileInBank([...fileInBank.concat(acceptedFiles)]);
          setValueForeign('fileInBank', acceptedFiles[0].name);
        }
        // Do something with the files
        setErrorFileInBank(false);
        triggerForeign('fileInBank');
        const formData = new FormData();

        formData.append('inputfile', acceptedFiles[0]);
        fileUploadMutation({
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data',
            Accept: undefined,
            'Accept-Language': undefined,
            'Accept-Encoding': undefined,
          },
        });
      }
    },
    [fileInBank]
  );

  const {
    handleSubmit,
    control,
    register,
    getValues,
    setValue,
    formState: { errors },
    clearErrors,
    trigger,
  } = useForm({ resolver: yupResolver(schemaAcc2Acc) });

  const {
    handleSubmit: handleSubmitInBank,
    control: controlInBank,
    register: registerInBank,
    getValues: getValuesInBank,
    setValue: setValueInBank,
    formState: { errors: errorsInBank },
    clearErrors: clearErrorsInBank,
    trigger: triggerInBank,
  } = useForm({
    resolver: yupResolver(schemaInBank),
    context: {
      fileRequiredInBank,
      contractNumberRequiredInBank,
      currencyOfToAccount:
        dataGetTransfer?.result !== 'error' ? dataGetBeneficiar?.customer_info?.currency : currencyOfToAccount,
    },
  });

  const {
    handleSubmit: handleSubmitLocalTransfer,
    control: controlLocalTransfer,
    register: registerLocalTransfer,
    getValues: getValuesLocalTransfer,
    setValue: setValueLocalTransfer,
    formState: { errors: errorsLocalTransfer },
    clearErrors: clearErrorsLocalTransfer,
    trigger: triggerLocalTransfer,
  } = useForm({
    resolver: yupResolver(schemaLocalTransfer),
    context: { customerTypeIsRequired, customerTypeVoenIsRequired, ipsIsRequired, fileRequiredLocal, selfPayment },
  });

  const {
    handleSubmit: handleSubmitEdv,
    control: controlEdv,
    register: registerEdv,
    getValues: getValuesEdv,
    setValue: setValueEdv,
    formState: { errors: errorsEdv },
    clearErrors: clearErrorsEdv,
    trigger: triggerEdv,
  } = useForm({
    resolver: yupResolver(schemaEdv),
  });

  const {
    handleSubmit: handleSubmitBudget,
    control: controlBudget,
    register: registerBudget,
    getValues: getValuesBudget,
    setValue: setValueBudget,
    formState: { errors: errorsBudget },
    clearErrors: clearErrorsBudget,
    trigger: triggerBudget,
  } = useForm({
    resolver: yupResolver(schemaBudget),
  });

  const {
    handleSubmit: handleSubmitConversion,
    control: controlConversion,
    register: registerConversion,
    getValues: getValuesConversion,
    setValue: setValueConversion,
    formState: { errors: errorsConversion },
    clearErrors: clearErrorsConversion,
    trigger: triggerConversion,
  } = useForm({
    resolver: yupResolver(schemaConversion),
    context: { checkIndividualConversion, selectedFromAccountConversion },
  });

  const {
    handleSubmit: handleSubmitForeign,
    control: controlForeign,
    register: registerForeign,
    getValues: getValuesForeign,
    setValue: setValueForeign,
    formState: { errors: errorsForeign },
    clearErrors: clearErrorsForeign,
    trigger: triggerForeign,
  } = useForm({
    resolver: yupResolver(schemaForeign),
    context: { mediatorBank, selectedCountries, avans },
  });

  useEffect(() => {
    if (pathUrl === 'transfer-page' && dataAccountTo !== null && dataAccountTo !== undefined && confirm !== 'true') {
      setSelectedToAccount(dataAccountTo);
      setValue('toAccount', dataAccountTo);
    }

    if (pathUrl === 'transfer-page' && templateData !== null && templateData !== undefined && confirm !== 'true') {
      if (pageId === null || pageId === 'payment_acc2acc') {
        setSelectedFromAccount(templateData.content_data.fromAccount);
        setValue('fromAccount', templateData.content_data.fromAccount);
        setAmountValue(templateData.amount);
        setValue('amount', templateData.amount);
        setSelectedToAccount(templateData.content_data.toAccount);
        setValue('toAccount', templateData.content_data.toAccount);
        setDefaultDesc(templateData.content_data.desc);
        setValueTextArea(templateData.content_data.desc);
        setValue('desc', templateData.content_data.desc);
      }

      if (pageId === 'payment_edv') {
        setSelectedFromAccount(templateData.content_data.fromAccount);
        setValueEdv('fromAccount', templateData.content_data.fromAccount);
        setCommission(templateData.content_data.comission);
        setValueEdv('commission', templateData.content_data.comission);
        setAmountValue(templateData.amount);
        setValueEdv('amount', templateData.amount);
        setVoenEdv(templateData.content_data.beneficiarVoen);
        setValueEdv('beneficiarVoen', templateData.content_data.beneficiarVoen);
        setBeneficiarNameEdv(templateData.content_data.beneficiarName);
        setValueEdv('beneficiarName', templateData.content_data.beneficiarName);
        setDefaultDesc(templateData.content_data.desc);
        setValueEdv('desc', templateData.content_data.desc);
        setValueTextArea(templateData.content_data.desc);
      }

      if (pageId === 'payment_budget') {
        setSelectedFromAccount(templateData.content_data.fromAccount);
        setValueBudget('fromAccount', templateData.content_data.fromAccount);
        setCommission(templateData.content_data.comission);
        setValueBudget('commission', templateData.content_data.comission);
        setAmountValue(templateData.amount);
        setValueBudget('amount', templateData.amount);
        setBudgetIban(templateData.content_data.toAccount);
        setValueBudget('budgetAccNumber', templateData.content_data.toAccount);
        setValueBudget('orgName', templateData.content_data.organization);
        setValueBudget('orgVoen', templateData.content_data.orgVoen);
        setSelectedBudgetLevelCodes(templateData.content_data.level_code);
        setValueBudget('levelCode', templateData.content_data.level_code);
        setClassCodeBudget(templateData.content_data.classification_code);
        setValueBudget('classCode', templateData.content_data.classification_code);
        setValueBudget('className', templateData.content_data.classification_name);
        setDefaultDesc(templateData.content_data.desc);
        setValueBudget('desc', templateData.content_data.desc);
        setValueTextArea(templateData.content_data.desc);
      }

      if (pageId === 'payment_interbank') {
        setSelectedFromAccount(templateData.content_data.fromAccount);
        setValueInBank('fromAccount', templateData.content_data.fromAccount);
        setAmountValue(templateData.amount);
        setValueInBank('amount', templateData.amount);
        setIbanField(templateData.content_data.toAccount);
        setValueInBank('toAccount', templateData.content_data.toAccount);
        setValueInBank('customerType', templateData.content_data.customerType);
        setValueInBank('beneficiarName', templateData.content_data.beneficiarName);
        setValueInBank('beneficiarVoen', templateData.content_data.beneficiarVoen);
        setValueInBank('contractNumber', templateData.content_data.contractNo);
        setDefaultDesc(templateData.content_data.desc);
        setValueTextArea(templateData.content_data.desc);
        setValueInBank('desc', templateData.content_data.desc);
        setValueInBank('fileInBank', templateData.content_data.files);
        setFileInBank(templateData.content_data.filesData);
        setFileInBankArray(templateData.content_data.files);
      }

      if (pageId === 'payment_conversion') {
        setSelectedFromAccountConversion(templateData.content_data.fromAccount);
        setValueConversion('fromAccount', templateData.content_data.fromAccount);
        setSelectedToAccountConversion(templateData.content_data.toAccount);
        setValueConversion('toAccount', templateData.content_data.fromAccount);
        setFromAmountConversion(templateData.content_data.fromAmount);
        setValueConversion('amountFrom', templateData.content_data.fromAmount);
        setToAmountConversion(templateData.content_data.toAmount);
        setValueConversion('amountTo', templateData.content_data.toAmount);
        setSelectedCommissionConversion(templateData.content_data.comission);
        setValueConversion('commission', templateData.content_data.comission);
        setCheckIndividualConversion(templateData.content_data.individual);
        if (
          templateData.content_data.customerRate !== undefined &&
          templateData.content_data.customerRate.length !== 0
        ) {
          setIndividualRates(templateData.content_data.customerRate);
          setValueConversion('customerRate', templateData.content_data.customerRate);
        }
        setRates(templateData.content_data.rates);
      }

      if (pageId === 'payment_local_transfer') {
        setSelectedFromAccount(templateData.content_data.fromAccount);
        setValueLocalTransfer('fromAccount', templateData.content_data.fromAccount);
        setCommission(templateData.content_data.comission);
        setValueLocalTransfer('commission', templateData.content_data.comission);
        setAmountValue(templateData.amount);
        setValueLocalTransfer('amount', templateData.amount);
        setSelectedOptions(templateData.content_data.transferSubType);
        setValueLocalTransfer('paymentType', templateData.content_data.transferSubType);
        setCustomerType(templateData.content_data.customerType);
        setValueLocalTransfer('customerType', templateData.content_data.customerType);
        setBankCodeValueLocal(templateData.content_data.branchCode);
        setValueLocalTransfer('bankCode', templateData.content_data.branchCode);
        setValueLocalTransfer('bankName', templateData.content_data.beneficiarBankName);
        setValueLocalTransfer('bankAccNumber', templateData.content_data.beneficiarBankAcNo);
        setSelfPayment(templateData.content_data.selfPayment);
        setVoenLocal(templateData.content_data.beneficiarVoen);
        setValueLocalTransfer('beneficiarVoen', templateData.content_data.beneficiarVoen);
        setBeneficiarNameLocal(templateData.content_data.beneficiarName);
        setValueLocalTransfer('beneficiarName', templateData.content_data.beneficiarName);
        setBeneficiarIbanLocal(templateData.content_data.beneficiarAccNo);
        setValueLocalTransfer('beneficiarAccNo', templateData.content_data.beneficiarAccNo);
        setValueLocalTransfer('contractNumber', templateData.content_data.contractNo);
        setDefaultDesc(templateData.content_data.desc);
        setValueLocalTransfer('desc', templateData.content_data.desc);
        setValueTextArea(templateData.content_data.desc);
        setFileInBank(templateData.content_data.filesData);
        setValueLocalTransfer('fileInBank', templateData.content_data.files);
        setFileInBankArray(templateData.content_data.files);
        setTaxEnabledLocal(templateData.content_data.taxEnabled);
      }

      if (pageId === 'payment_foreign_transfer') {
        setSelectedFromAccount(templateData.content_data.fromAccount);
        setValueForeign('fromAccount', templateData.content_data.fromAccount);
        setCommission(templateData.content_data.comission);
        setValueForeign('commission', templateData.content_data.comission);
        setAmountValue(templateData.amount);
        setValueForeign('amount', templateData.amount);
        setSelectedCountries(templateData.content_data.country);
        setValueForeign('country', templateData.content_data.country);
        setSwiftCodeForeign(templateData.content_data.beneficiarSwift);
        setValueForeign('swiftBic', templateData.content_data.beneficiarSwift);
        setValueForeign('beneficiarBankName', templateData.content_data.beneficiarBankName);
        setValueForeign('beneficiarAccNumber', templateData.content_data.beneficiarAccNo);
        setBeneficiarNameForeign(templateData.content_data.beneficiarName);
        setValueForeign('beneficiarName', templateData.content_data.beneficiarName);
        setBeneficiarAddressForeign(templateData.content_data.beneficiarAddress);
        setValueForeign('beneficiarAddress', templateData.content_data.beneficiarAddress);
        setMediatorBank(templateData.content_data.switchSwift);
        setValueForeign('midBankSwiftBic', templateData.content_data.middleSwiftBic);
        setValueForeign('midBankName', templateData.content_data.midBankName);
        setValueForeign('midBankAccNumber', templateData.content_data.midBankAccNumber);
        setKppForeign(templateData.content_data.kpp);
        setValueForeign('beneficiarKpp', templateData.content_data.kpp);
        setInnForeign(templateData.content_data.inn);
        setValueForeign('beneficiarInn', templateData.content_data.inn);
        setAvans(templateData.content_data.avans);
        setInvoiceValue(templateData.content_data.invoiceNo);
        setValueForeign('invoiceNo', templateData.content_data.invoiceNo);
        setValueForeign('contractNumber', templateData.content_data.contractNo);
        setDefaultDesc(templateData.content_data.desc);
        setValueForeign('desc', templateData.content_data.desc);
        setValueTextArea(templateData.content_data.desc);
        setFileInBank(templateData.content_data.filesData);
        setValueForeign('fileInBank', templateData.content_data.files);
        setFileInBankArray(templateData.content_data.files);
        setTaxEnabledLocal(templateData.content_data.taxEnabled);
      }
    }

    if (pathUrl.endsWith('edit-template')) {
      if (pageId === null || pageId === 'payment_acc2acc') {
        setSelectedFromAccount(templateData.content_data.fromAccount);
        setValue('fromAccount', templateData.content_data.fromAccount);
        setAmountValue(templateData.amount);
        setValue('amount', templateData.amount);
        setSelectedToAccount(templateData.content_data.toAccount);
        setValue('toAccount', templateData.content_data.toAccount);
        setDefaultDesc(templateData.content_data.desc);
        setValueTextArea(templateData.content_data.desc);
        setValue('desc', templateData.content_data.desc);
      }

      if (pageId === 'payment_interbank') {
        setSelectedFromAccount(templateData.content_data.fromAccount);
        setValueInBank('fromAccount', templateData.content_data.fromAccount);
        setAmountValue(templateData.amount);
        setValueInBank('amount', templateData.amount);
        setIbanField(templateData.content_data.toAccount);
        setValueInBank('toAccount', templateData.content_data.toAccount);
        setValueInBank('customerType', templateData.content_data.customerType);
        setValueInBank('beneficiarName', templateData.content_data.beneficiarName);
        setValueInBank('beneficiarVoen', templateData.content_data.beneficiarVoen);
        setValueInBank('contractNumber', templateData.content_data.contractNo);
        setDefaultDesc(templateData.content_data.desc);
        setValueTextArea(templateData.content_data.desc);
        setValueInBank('desc', templateData.content_data.desc);
        setValueInBank('fileInBank', templateData.content_data.files);
        setFileInBank(templateData.content_data.filesData);
        setFileInBankArray(templateData.content_data.files);
      }

      if (pageId === 'payment_edv') {
        setSelectedFromAccount(templateData.content_data.fromAccount);
        setValueEdv('fromAccount', templateData.content_data.fromAccount);
        setCommission(templateData.content_data.comission);
        setValueEdv('commission', templateData.content_data.comission);
        setAmountValue(templateData.amount);
        setValueEdv('amount', templateData.amount);
        setVoenEdv(templateData.content_data.beneficiarVoen);
        setValueEdv('beneficiarVoen', templateData.content_data.beneficiarVoen);
        setBeneficiarNameEdv(templateData.content_data.beneficiarName);
        setValueEdv('beneficiarName', templateData.content_data.beneficiarName);
        setDefaultDesc(templateData.content_data.desc);
        setValueEdv('desc', templateData.content_data.desc);
        setValueTextArea(templateData.content_data.desc);
      }

      if (pageId === 'payment_budget') {
        setSelectedFromAccount(templateData.content_data.fromAccount);
        setValueBudget('fromAccount', templateData.content_data.fromAccount);
        setCommission(templateData.content_data.comission);
        setValueBudget('commission', templateData.content_data.comission);
        setAmountValue(templateData.amount);
        setValueBudget('amount', templateData.amount);
        setBudgetIban(templateData.content_data.toAccount);
        setValueBudget('budgetAccNumber', templateData.content_data.toAccount);
        setValueBudget('orgName', templateData.content_data.organization);
        setValueBudget('orgVoen', templateData.content_data.orgVoen);
        setSelectedBudgetLevelCodes(templateData.content_data.level_code);
        setValueBudget('levelCode', templateData.content_data.level_code);
        setClassCodeBudget(templateData.content_data.classification_code);
        setValueBudget('classCode', templateData.content_data.classification_code);
        setValueBudget('className', templateData.content_data.classification_name);
        setDefaultDesc(templateData.content_data.desc);
        setValueBudget('desc', templateData.content_data.desc);
        setValueTextArea(templateData.content_data.desc);
      }

      if (pageId === 'payment_conversion') {
        setSelectedFromAccountConversion(templateData.content_data.fromAccount);
        setValueConversion('fromAccount', templateData.content_data.fromAccount);
        setSelectedToAccountConversion(templateData.content_data.toAccount);
        setValueConversion('toAccount', templateData.content_data.fromAccount);
        setFromAmountConversion(templateData.content_data.fromAmount);
        setValueConversion('amountFrom', templateData.content_data.fromAmount);
        setToAmountConversion(templateData.content_data.toAmount);
        setValueConversion('amountTo', templateData.content_data.toAmount);
        setSelectedCommissionConversion(templateData.content_data.comission);
        setValueConversion('commission', templateData.content_data.commission);
        setCheckIndividualConversion(templateData.content_data.individual);
        setIndividualRates(templateData.content_data.customerRate);
        setValueConversion('customerRate', templateData.content_data.customerRate);
        setRates(templateData.content_data.rates);
      }

      if (pageId === 'payment_local_transfer') {
        setSelectedFromAccount(templateData.content_data.fromAccount);
        setValueLocalTransfer('fromAccount', templateData.content_data.fromAccount);
        setCommission(templateData.content_data.comission);
        setValueLocalTransfer('commission', templateData.content_data.comission);
        setAmountValue(templateData.amount);
        setValueLocalTransfer('amount', templateData.amount);
        setSelectedOptions(templateData.content_data.transferSubType);
        setValueLocalTransfer('paymentType', templateData.content_data.transferSubType);
        setCustomerType(templateData.content_data.customerType);
        setValueLocalTransfer('customerType', templateData.content_data.customerType);
        setBankCodeValueLocal(templateData.content_data.branchCode);
        setValueLocalTransfer('bankCode', templateData.content_data.branchCode);
        setValueLocalTransfer('bankName', templateData.content_data.beneficiarBankName);
        setValueLocalTransfer('bankAccNumber', templateData.content_data.beneficiarBankAcNo);
        setSelfPayment(templateData.content_data.selfPayment);
        setVoenLocal(templateData.content_data.beneficiarVoen);
        setValueLocalTransfer('beneficiarVoen', templateData.content_data.beneficiarVoen);
        setBeneficiarNameLocal(templateData.content_data.beneficiarName);
        setValueLocalTransfer('beneficiarName', templateData.content_data.beneficiarName);
        setBeneficiarIbanLocal(templateData.content_data.beneficiarAccNo);
        setValueLocalTransfer('beneficiarAccNo', templateData.content_data.beneficiarAccNo);
        setValueLocalTransfer('contractNumber', templateData.content_data.contractNo);
        setDefaultDesc(templateData.content_data.desc);
        setValueLocalTransfer('desc', templateData.content_data.desc);
        setValueTextArea(templateData.content_data.desc);
        setValueLocalTransfer('fileInBank', templateData.content_data.files);
        setFileInBank(templateData.content_data.filesData);
        setFileInBankArray(templateData.content_data.files);
        setTaxEnabledLocal(templateData.content_data.taxEnabled);
      }

      if (pageId === 'payment_foreign_transfer') {
        setSelectedFromAccount(templateData.content_data.fromAccount);
        setValueForeign('fromAccount', templateData.content_data.fromAccount);
        setCommission(templateData.content_data.comission);
        setValueForeign('commission', templateData.content_data.comission);
        setAmountValue(templateData.amount);
        setValueForeign('amount', templateData.amount);
        setSelectedCountries(templateData.content_data.country);
        setValueForeign('country', templateData.content_data.country);
        setSwiftCodeForeign(templateData.content_data.beneficiarSwift);
        setValueForeign('swiftBic', templateData.content_data.beneficiarSwift);
        setValueForeign('beneficiarBankName', templateData.content_data.beneficiarBankName);
        setValueForeign('beneficiarAccNumber', templateData.content_data.beneficiarAccNo);
        setBeneficiarNameForeign(templateData.content_data.beneficiarName);
        setValueForeign('beneficiarName', templateData.content_data.beneficiarName);
        setBeneficiarAddressForeign(templateData.content_data.beneficiarAddress);
        setValueForeign('beneficiarAddress', templateData.content_data.beneficiarAddress);
        setMediatorBank(templateData.content_data.switchSwift);
        setValueForeign('midBankSwiftBic', templateData.content_data.middleSwiftBic);
        setValueForeign('midBankName', templateData.content_data.midBankName);
        setValueForeign('midBankAccNumber', templateData.content_data.midBankAccNumber);
        setKppForeign(templateData.content_data.kpp);
        setValueForeign('beneficiarKpp', templateData.content_data.kpp);
        setInnForeign(templateData.content_data.inn);
        setValueForeign('beneficiarInn', templateData.content_data.inn);
        setAvans(templateData.content_data.avans);
        setInvoiceValue(templateData.content_data.invoiceNo);
        setValueForeign('invoiceNo', templateData.content_data.invoiceNo);
        setValueForeign('contractNumber', templateData.content_data.contractNo);
        setDefaultDesc(templateData.content_data.desc);
        setValueForeign('desc', templateData.content_data.desc);
        setValueTextArea(templateData.content_data.desc);
        setValueForeign('fileInBank', templateData.content_data.files);
        setFileInBank(templateData.content_data.filesData);
        setFileInBankArray(templateData.content_data.files);
        setTaxEnabledLocal(templateData.content_data.taxEnabled);
      }
    }
  }, []);

  // Check for bugs later

  // useEffect(() => {
  //   if (
  //     pathUrl === 'transfer-page' &&
  //     (templateData === null || templateData === undefined) &&
  //     (dataAccountTo === null || dataAccountTo === undefined) &&
  //     confirm !== 'true'
  //   ) {
  //     refetchGetDataTransfer();
  //     handleLeavePage();
  //   }
  // }, [pathUrl, pageId]);

  useEffect(() => {
    if (dataFileUpload?.result === 'success' && fileInBankArray.length === 0) {
      setFileInBankArray([dataFileUpload?.file_id]);
    } else if (dataFileUpload?.result === 'success' && fileInBankArray.length > 0) {
      setFileInBankArray([...fileInBankArray, dataFileUpload?.file_id]);
    }
  }, [dataFileUpload]);

  useEffect(() => {
    if (dataGetIpsData !== undefined && dataGetIpsData?.result !== 'error') {
      setValueLocalTransfer('bankCode', dataGetIpsData?.bank_data[0].bank_code);
      setValueLocalTransfer('bankName', dataGetIpsData?.bank_data[0].branch_name);
      setValueLocalTransfer('bankAccNumber', dataGetIpsData?.bank_data[0].corr_acc);
      setValueLocalTransfer('beneficiarVoen', dataGetIpsData?.ips_data.voen);
      setValueLocalTransfer('beneficiarName', dataGetIpsData?.ips_data.full_name);
      setValueLocalTransfer('beneficiarAccNo', dataGetIpsData?.ips_data.iban);
    }
    if (dataGetIpsData?.result === 'error') {
      if (dataGetIpsData?.error.text !== undefined || dataGetIpsData?.error.text.length > 0) {
        setOpenSnackBar(true);
      }
    }
  }, [dataGetIpsData]);

  useEffect(() => {
    if (dataGetBeneficiar !== undefined && dataGetBeneficiar?.result !== 'error') {
      setFileRequiredInBank(dataGetBeneficiar?.is_file_required);
      setContractNumberRequiredInBank(dataGetBeneficiar?.is_contract_required);
      setCurrencyOfToAccount(dataGetBeneficiar?.customer_info.currency);
      setValueInBank('beneficiarName', dataGetBeneficiar?.customer_info.full_name);
      setValueInBank('beneficiarVoen', dataGetBeneficiar?.customer_info.tax_number);
      setValueInBank('customerType', dataGetBeneficiar?.customer_info.customer_type.title);
      if (selectedFromAccount?.currency !== dataGetBeneficiar?.customer_info.currency) {
        triggerInBank('toAccount');
      }
    }

    if (dataGetBeneficiar?.result === 'error') {
      if (dataGetBeneficiar?.error.text !== undefined || dataGetBeneficiar?.error.text.length > 0) {
        setOpenSnackBar(true);
      }
    }
  }, [dataGetBeneficiar]);

  useEffect(() => {
    if (dataAcc2acc?.form_id === 'confirm_payment') {
      navigate(`${lang}/transfer-page?confirm=true`);
    }
    if (dataAcc2acc?.result === 'error') {
      if (dataAcc2acc?.error.text !== undefined || dataAcc2acc?.error.text.length > 0) {
        setOpenSnackBar(true);
      }
    }
  }, [dataAcc2acc]);

  useEffect(() => {
    if (dataGetTransfer !== undefined && (templateData === null || templateData === undefined)) {
      const from = dataGetTransfer?.accounts?.map((item: any) => {
        return {
          value: item.iban,
          label: `${item.emp_title} - ${item.main_balance} ${useCurrencySymbol(item.currency)}`,
          currency: item.currency,
          balance: item.main_balance,
        };
      });
      setFromAccount(from);
    } else if (dataGetTransfer !== undefined && templateData !== null && templateData !== undefined) {
      const from = dataGetTransfer?.accounts?.map((item: any) => {
        return {
          value: item.iban,
          label: `${item.emp_title} - ${item.main_balance} ${useCurrencySymbol(item.currency)}`,
          currency: item.currency,
          balance: item.main_balance,
        };
      });

      setSelectedFromAccount(
        templateData?.content_data.fromAccount === undefined
          ? undefined
          : from.find((item: any) => item.value === templateData?.content_data.fromAccount.value)
      );
      setCommission(
        templateData?.content_data.comission === undefined
          ? undefined
          : from.find((item: any) => item.value === templateData?.content_data.comission.value)
      );
      setSelectedCommissionConversion(
        templateData?.content_data.comission === undefined
          ? undefined
          : from.find((item: any) => item.value === templateData?.content_data.comission.value)
      );
      setFromAccount(from);

      handleCheckTemplateBtn();
    }
  }, [dataGetTransfer]);

  useEffect(() => {
    if (pageId === null) {
      setValuePageId('payment_acc2acc');
      // sendTransferTypeMutation({
      //   businessKey: dataGetTransfer?.business_key,
      //   data: { transfer_type: 'payment_acc2acc' },
      // });
    } else {
      setValuePageId(pageId);
      // setSelectedFromAccount(null);
      // setValue('toAccount', null);
      // setSelectedToAccount(null);
      // setDisabledToAccount(true);
      // setValue('amount', null);
      // sendTransferTypeMutation({
      //   businessKey: dataGetTransfer?.business_key,
      //   data: { transfer_type: valuePageId },
      // });
    }
  }, [pageId]);

  const [errorSaveTemplate, setErrorSaveTemplate] = useState(false);

  useEffect(() => {
    if (dataCreateTemplate?.result === 'accepted') {
      setSaveTemplateSuccess(true);
    }

    if (dataCreateTemplate?.result === 'error') {
      setErrorSaveTemplate(true);
    }

    if (dataEditTemplate?.result === 'accepted') {
      setSaveTemplateSuccess(true);
    }
  }, [dataCreateTemplate, dataEditTemplate]);

  useEffect(() => {
    refetchGetDataTransfer();
  }, [lang]);

  useEffect(() => {
    if (openBankCodeLocalTransferDialog) {
      getBeneficiarDataLocalTransferMutation({
        businessKey: dataGetTransfer?.business_key,
        data: {
          search: '',
          action: 'bank_code',
          offset: 0,
        },
      });
    }

    if (!openBankCodeLocalTransferDialog) {
      setBankCodeData([]);
    }
  }, [openBankCodeLocalTransferDialog]);

  useEffect(() => {
    if (openBudgetOrgDialog) {
      getClassificationMutation({
        businessKey: dataGetTransfer?.business_key,
        data: {
          search: '',
          offset: 0,
        },
      });
    }

    if (!openBudgetOrgDialog) {
      setBankCodeData([]);
    }
  }, [openBudgetOrgDialog]);

  useEffect(() => {
    if (openSwiftBicCode) {
      getSwiftCodeMutation({
        businessKey: dataGetTransfer?.business_key,
        data: {
          search: '',
          offset: 0,
          name: `bank_bic`,
          bic_code: selectedCountries.bicCode,
          currency: selectedFromAccount.currency,
        },
      });
    }

    if (openMediatorSwiftBicCode) {
      getSwiftCodeMutation({
        businessKey: dataGetTransfer?.business_key,
        data: {
          search: '',
          offset: 0,
          name: `int_bank_bic`,
          // bic_code: selectedCountries.bicCode,
          // currency: selectedFromAccount.currency,
        },
      });
    }

    if (!openSwiftBicCode || !openMediatorSwiftBicCode) {
      setBankCodeData([]);
    }
  }, [openSwiftBicCode, openMediatorSwiftBicCode]);

  useEffect(() => {
    // if (pathUrl === 'transfer-page' && templateData === null) {
    if (dataSendTransferType !== undefined) {
      getDataFromTransferType(dataSendTransferType);
    } else {
      getDataFromTransferType(dataSendTransferTypeFromGetData);
    }
    // }
  }, [dataSendTransferType, dataSendTransferTypeFromGetData]);

  const getDataFromTransferType = (from: any) => {
    const commissionOptionDropdown = dataGetTransfer?.accounts.map((item: any) => {
      return {
        value: item.iban,
        label: `${item.emp_title} - ${item.main_balance} ${useCurrencySymbol(item.currency)}`,
        currency: item.currency,
        balance: item.main_balance,
      };
    });

    setCommissionOption(commissionOptionDropdown);

    if (from?.form_id === 'payment_acc2acc' && (templateData === null || templateData === undefined)) {
      setDefaultDesc(from?.default_description);
      setValue('desc', from?.default_description);
      setValueTextArea(from?.default_description);
    } else if (from?.form_id === 'payment_acc2acc' && templateData !== null && templateData !== undefined) {
      setDefaultDesc(templateData.content_data.desc);
      setValueTextArea(templateData.content_data.desc);
      setValue('desc', templateData.content_data.desc);
    }

    if (from?.form_id !== 'payment_acc2acc' && (templateData === null || templateData === undefined)) {
      setValueTextArea('');
      setDefaultDesc('');
      setValue('desc', '');
    }

    if (from?.transfer_subtypes) {
      const options = from?.transfer_subtypes.map((item: any) => {
        return {
          value: item.code,
          label: item.title,
          customerType: item.code === 'AZIPS' || item.code === 'XOHKS' ? item.customer_type : item.alias_type,
        };
      });

      setCountryOptions(options);

      const fromOnlyManat = dataGetTransfer?.accounts
        .filter((item: any) => item.currency === 'AZN')
        .map((item: any) => {
          return {
            value: item.iban,
            label: `${item.emp_title} - ${item.main_balance} ${useCurrencySymbol(item.currency)}`,
            currency: item.currency,
            balance: item.main_balance,
          };
        });

      setFromAccount(fromOnlyManat);
    }

    if (from?.edv_details) {
      setValueEdv('beneficiarBankCode', from?.edv_details.branch_code);
      setValueEdv('beneficiarBankName', from?.edv_details.branch_name);
      setValueEdv('beneficiarBankAccNumber', from?.edv_details.corr_acc);
      setValueEdv('beneficiarAccNumber', from?.edv_details.corr_acc_sub);

      const fromOnlyManat = dataGetTransfer?.accounts
        .filter((item: any) => item.currency === 'AZN')
        .map((item: any) => {
          return {
            value: item.iban,
            label: `${item.emp_title} - ${item.main_balance} ${useCurrencySymbol(item.currency)}`,
            currency: item.currency,
            balance: item.main_balance,
          };
        });

      setFromAccount(fromOnlyManat);
    }

    if (from?.form_id === 'payment_budget') {
      const options = from?.level_codes.map((item: any) => {
        return {
          value: item.tax,
          label: `${item.tax} - ${item.branch_name}`,
        };
      });

      setBudgetLevelCodes(options);

      const fromOnlyManat = dataGetTransfer?.accounts
        .filter((item: any) => item.currency === 'AZN')
        .map((item: any) => {
          return {
            value: item.iban,
            label: `${item.emp_title} - ${item.main_balance} ${useCurrencySymbol(item.currency)}`,
            currency: item.currency,
            balance: item.main_balance,
          };
        });

      setFromAccount(fromOnlyManat);
    }

    if (from?.form_id === 'payment_conversion') {
      const fromData = from?.accounts.map((item: any) => {
        return {
          value: item.iban,
          label: `${item.product_name} - ${item.main_balance} ${useCurrencySymbol(item.currency)}`,
          currency: item.currency,
          balance: item.main_balance,
        };
      });
      const ratesData = from?.rates.map((item: any) => {
        return {
          value: item.currency,
          label: item.currency,
          icon: item.flag_png,
          sell: item.sell,
          buy: item.buy,
        };
      });
      setRates(ratesData);
      setOptionsConversion(fromData);
      if (templateData !== null && templateData !== undefined) {
        setSelectedFromAccountConversion(
          fromData.find((item: any) => item.value === templateData.content_data.fromAccount.value)
        );
        setSelectedToAccountConversion(templateData.content_data.toAccount);

        setFromAccountConversion(
          fromData.filter((item: any) => item.currency !== templateData.content_data.toAccount.currency)
        );
        setToAccountConversion(
          fromData.filter((item: any) => item.currency !== templateData.content_data.fromAccount.currency)
        );
      } else {
        setFromAccountConversion(fromData);
        setToAccountConversion(fromData);
      }
    }

    if (from?.form_id === 'payment_foreign_transfer') {
      const countriesData = from?.countries.map((item: any) => {
        return {
          value: item.country_code,
          label: item.name,
          bicCode: item.bic_code,
        };
      });

      setCountries(countriesData);

      const fromNotManat = dataGetTransfer?.accounts
        .filter((item: any) => item.currency !== 'AZN')
        .map((item: any) => {
          return {
            value: item.iban,
            label: `${item.emp_title} - ${item.main_balance} ${useCurrencySymbol(item.currency)}`,
            currency: item.currency,
            balance: item.main_balance,
          };
        });

      setFromAccount(fromNotManat);
    }
  };

  useEffect(() => {
    if (valuePageId === 'payment_local_transfer' || valuePageId === 'payment_edv' || valuePageId === 'payment_budget') {
      const fromOnlyManat = dataGetTransfer?.accounts
        .filter((item: any) => item.currency === 'AZN')
        .map((item: any) => {
          return {
            value: item.iban,
            label: `${item.emp_title} - ${item.main_balance} ${useCurrencySymbol(item.currency)}`,
            currency: item.currency,
            balance: item.main_balance,
          };
        });

      setFromAccount(fromOnlyManat);
    }

    if (valuePageId === 'payment_foreign_transfer') {
      const fromNotManat = dataGetTransfer?.accounts
        .filter((item: any) => item.currency !== 'AZN')
        .map((item: any) => {
          return {
            value: item.iban,
            label: `${item.emp_title} - ${item.main_balance} ${useCurrencySymbol(item.currency)}`,
            currency: item.currency,
            balance: item.main_balance,
          };
        });

      setFromAccount(fromNotManat);
    }

    if (valuePageId === 'payment_acc2acc' || valuePageId === 'payment_interbank') {
      const allAccounts = dataGetTransfer?.accounts.map((item: any) => {
        return {
          value: item.iban,
          label: `${item.emp_title} - ${item.main_balance} ${useCurrencySymbol(item.currency)}`,
          currency: item.currency,
          balance: item.main_balance,
        };
      });

      setFromAccount(allAccounts);
    }

    setCheckLeave(false);
  }, [valuePageId]);

  // useEffect(() => {
  //   if (!openAlertModal) {
  //     setSelectedToAccount(null);
  //     setValue('toAccount', null);
  //   }
  // }, [openAlertModal]);

  useEffect(() => {
    if (selectedFromAccount !== undefined) {
      const to = fromAccount?.filter((item: any) => item?.value !== selectedFromAccount?.value);
      setToAccount(to);
      if (selectedFromAccount?.value === selectedToAccount?.value) {
        setSelectedToAccount(null);
      }

      if (+selectedFromAccount?.balance > +getValues('amount')) {
        clearErrors('amount');
      }
      if (selectedFromAccount !== null && selectedFromAccount !== undefined) {
        setDisabledToAccount(false);
      }
    }
  }, [selectedFromAccount]);

  useEffect(() => {
    if (dataGetBeneficiarDataLocalTransfer?.result !== 'error') {
      if (dataGetBeneficiarDataLocalTransfer?.banks.length === 1 && !openBankCodeLocalTransferDialog) {
        setValueLocalTransfer('bankName', dataGetBeneficiarDataLocalTransfer?.banks[0].branch_name);
        setValueLocalTransfer('bankAccNumber', dataGetBeneficiarDataLocalTransfer?.banks[0].corr_acc);
        setBankCodeData([]);
      } else if (dataGetBeneficiarDataLocalTransfer?.banks.length === 1) {
        // setValueLocalTransfer('bankName', dataGetBeneficiarDataLocalTransfer?.banks[0].branch_name);
        // setValueLocalTransfer('bankAccNumber', dataGetBeneficiarDataLocalTransfer?.banks[0].corr_acc);
        setBankCodeData(dataGetBeneficiarDataLocalTransfer?.banks);
      } else {
        setBankCodeData([...bankCodeData, ...(dataGetBeneficiarDataLocalTransfer?.banks || [])]);
        if (isSearchLocalTransfer) {
          setBankCodeData([...(dataGetBeneficiarDataLocalTransfer?.banks || [])]);
        }
      }
    }
    if (dataGetBeneficiarDataLocalTransfer?.result === 'error') {
      if (
        dataGetBeneficiarDataLocalTransfer?.error.text !== undefined ||
        dataGetBeneficiarDataLocalTransfer?.error.text.length > 0
      ) {
        setOpenSnackBar(true);
      }
    }
  }, [dataGetBeneficiarDataLocalTransfer]);

  useEffect(() => {
    if (dataGetOrganization !== undefined && dataGetOrganization?.result !== 'error') {
      setValueBudget('orgName', dataGetOrganization?.list[0].name);
      setValueBudget('orgVoen', dataGetOrganization?.list[0].tax);
    }
    if (dataGetOrganization?.result === 'error') {
      if (dataGetOrganization?.error.text !== undefined || dataGetOrganization?.error.text.length > 0) {
        setOpenSnackBar(true);
      }
    }
  }, [dataGetOrganization]);

  useEffect(() => {
    if (dataGetClassification?.result !== 'error') {
      if (dataGetClassification?.list.length === 1 && !openBudgetOrgDialog) {
        setValueBudget('className', dataGetClassification?.list[0].classification);
        setBankCodeData([]);
      } else if (dataGetClassification?.list.length === 1) {
        // setValueBudget('className', dataGetClassification?.list[0].classification);
        setBankCodeData(dataGetClassification?.list);
      } else {
        setBankCodeData([...bankCodeData, ...(dataGetClassification?.list || [])]);
        if (isSearchLocalTransfer) {
          setBankCodeData([...(dataGetClassification?.list || [])]);
        }
      }
    }
    if (dataGetClassification?.result === 'error') {
      if (dataGetOrganization?.error.text !== undefined || dataGetOrganization?.error.text.length > 0) {
        setOpenSnackBar(true);
      }
    }
  }, [dataGetClassification]);

  useEffect(() => {
    if (dataSwiftCode?.result !== 'error') {
      if (dataSwiftCode?.list.length === 1 && !openSwiftBicCode && swiftBicCodeForeign) {
        setValueForeign('beneficiarBankName', dataSwiftCode.list[0].name);
        setBankCodeData([]);
      } else if (dataSwiftCode?.list.length === 1 && !openMediatorSwiftBicCode && swiftMediatorBicCodeForeign) {
        setValueForeign('midBankName', dataSwiftCode.list[0].name);
        setBankCodeData([]);
      } else if (dataSwiftCode?.list.length === 1) {
        setBankCodeData(dataSwiftCode?.list);
      } else if (dataSwiftCode?.list.length === 0) {
        setValueForeign('beneficiarBankName', '');
      } else {
        setBankCodeData([...bankCodeData, ...(dataSwiftCode?.list || [])]);

        if (isSearchLocalTransfer) {
          setBankCodeData([...(dataSwiftCode?.list || [])]);
        }
      }

      handleCheckTemplateBtn();
    }
    if (dataSwiftCode?.result === 'error') {
      if (dataSwiftCode?.error.text !== undefined || dataGetOrganization?.error.text.length > 0) {
        setOpenSnackBar(true);
      }
    }
  }, [dataSwiftCode]);

  const handleCheckTemplateBtn = (individual?: any) => {
    if (pageId === null || valuePageId === 'payment_acc2acc') {
      if (
        getValues('amount') !== undefined &&
        getValues('amount') !== null &&
        getValues('amount').toString() !== '' &&
        getValues('fromAccount') !== undefined &&
        getValues('toAccount') !== null &&
        getValues('toAccount') !== undefined
      ) {
        setShowTemplate(true);
      } else {
        setShowTemplate(false);
      }
    }

    if (valuePageId === 'payment_interbank') {
      if (
        getValuesInBank('amount') !== null &&
        getValuesInBank('amount').toString() !== '' &&
        getValuesInBank('desc').length > 0 &&
        getValuesInBank('fromAccount') !== undefined &&
        getValuesInBank('toAccount').length > 0
      ) {
        if (contractNumberRequiredInBank) {
          if (getValuesInBank('contractNumber').length > 0) {
            setShowTemplate(true);
          } else {
            setShowTemplate(false);
          }
        } else {
          setShowTemplate(true);
        }
      } else {
        setShowTemplate(false);
      }
    }

    if (valuePageId === 'payment_local_transfer') {
      if (
        getValuesLocalTransfer('amount') !== null &&
        getValuesLocalTransfer('amount').toString() !== '' &&
        getValuesLocalTransfer('desc').length > 0 &&
        getValuesLocalTransfer('fromAccount') !== undefined &&
        getValuesLocalTransfer('commission') !== null &&
        getValuesLocalTransfer('commission') !== undefined &&
        getValuesLocalTransfer('paymentType') !== null &&
        getValuesLocalTransfer('paymentType') !== undefined &&
        getValuesLocalTransfer('customerType') !== undefined &&
        getValuesLocalTransfer('bankCode') !== undefined &&
        getValuesLocalTransfer('bankCode').length > 0 &&
        getValuesLocalTransfer('beneficiarVoen') !== undefined &&
        getValuesLocalTransfer('beneficiarVoen').length > 0 &&
        getValuesLocalTransfer('beneficiarName') !== undefined &&
        getValuesLocalTransfer('beneficiarName').length > 0 &&
        getValuesLocalTransfer('beneficiarAccNo') !== undefined &&
        getValuesLocalTransfer('beneficiarAccNo').length > 0
      ) {
        if (selfPayment) {
          if (getValuesLocalTransfer('contractNumber').length > 0) {
            setShowTemplate(true);
          } else {
            setShowTemplate(false);
          }
        } else {
          setShowTemplate(true);
        }
      } else {
        setShowTemplate(false);
      }
    }

    if (valuePageId === 'payment_foreign_transfer') {
      if (individual && getValuesForeign('country.value') !== 'RUS') {
        if (
          getValuesForeign('amount') !== null &&
          getValuesForeign('amount').toString() !== '' &&
          getValuesForeign('desc').length > 0 &&
          getValuesForeign('fromAccount') !== undefined &&
          getValuesForeign('commission') !== undefined &&
          getValuesForeign('contractNumber').length > 0 &&
          getValuesForeign('country') !== undefined &&
          // fileInBank.length > 0 &&
          // fileInBankArray.length > 0 &&
          getValuesForeign('swiftBic').length > 0 &&
          getValuesForeign('beneficiarAccNumber').length > 0 &&
          getValuesForeign('beneficiarName').length > 0 &&
          getValuesForeign('beneficiarAddress').length > 0 &&
          // getValuesForeign('midBankSwiftBic').length > 0 &&
          // getValuesForeign('midBankAccNumber').length > 0 &&
          getValuesForeign('invoiceNo') !== undefined &&
          getValuesForeign('invoiceNo').length > 0
        ) {
          logger.log('in avans && !== RUS');
          setShowTemplate(true);
        } else {
          logger.log('in avans || !== RUS');
          setShowTemplate(false);
        }
      } else if (individual && getValuesForeign('country.value') === 'RUS') {
        if (
          getValuesForeign('amount') !== null &&
          getValuesForeign('amount').toString() !== '' &&
          getValuesForeign('desc').length > 0 &&
          getValuesForeign('fromAccount') !== undefined &&
          getValuesForeign('commission') !== undefined &&
          getValuesForeign('contractNumber').length > 0 &&
          getValuesForeign('country') !== undefined &&
          // fileInBank.length > 0 &&
          // fileInBankArray.length > 0 &&
          getValuesForeign('swiftBic').length > 0 &&
          getValuesForeign('beneficiarAccNumber').length > 0 &&
          getValuesForeign('beneficiarName').length > 0 &&
          getValuesForeign('beneficiarAddress').length > 0 &&
          // getValuesForeign('midBankSwiftBic').length > 0 &&
          // getValuesForeign('midBankAccNumber').length > 0 &&
          getValuesForeign('invoiceNo').length > 0 &&
          getValuesForeign('beneficiarKpp').length > 0 &&
          getValuesForeign('beneficiarInn').length > 0
        ) {
          setShowTemplate(true);
        } else {
          setShowTemplate(false);
        }
      } else if (!individual && getValuesForeign('country.value') !== 'RUS') {
        if (
          getValuesForeign('amount') !== null &&
          getValuesForeign('amount').toString() !== '' &&
          getValuesForeign('desc').length > 0 &&
          getValuesForeign('fromAccount') !== undefined &&
          getValuesForeign('commission') !== undefined &&
          getValuesForeign('contractNumber').length > 0 &&
          getValuesForeign('country') !== undefined &&
          // fileInBank.length > 0 &&
          // fileInBankArray.length > 0 &&
          getValuesForeign('swiftBic').length > 0 &&
          getValuesForeign('beneficiarAccNumber').length > 0 &&
          getValuesForeign('beneficiarName').length > 0 &&
          getValuesForeign('beneficiarAddress').length > 0
          // getValuesForeign('midBankSwiftBic').length > 0 &&
          // getValuesForeign('midBankAccNumber').length > 0 &&
        ) {
          logger.log('in if');
          setShowTemplate(true);
        } else {
          logger.log('in else');
          setShowTemplate(false);
        }
      } else if (!individual && getValuesForeign('country.value') === 'RUS') {
        if (
          getValuesForeign('amount') !== null &&
          getValuesForeign('amount').toString() !== '' &&
          getValuesForeign('desc').length > 0 &&
          getValuesForeign('fromAccount') !== undefined &&
          getValuesForeign('commission') !== undefined &&
          getValuesForeign('contractNumber').length > 0 &&
          getValuesForeign('country') !== undefined &&
          // fileInBank.length > 0 &&
          // fileInBankArray.length > 0 &&
          getValuesForeign('swiftBic').length > 0 &&
          getValuesForeign('beneficiarAccNumber').length > 0 &&
          getValuesForeign('beneficiarName').length > 0 &&
          getValuesForeign('beneficiarAddress').length > 0 &&
          // getValuesForeign('midBankSwiftBic').length > 0 &&
          // getValuesForeign('midBankAccNumber').length > 0 &&
          getValuesForeign('beneficiarKpp').length > 0 &&
          getValuesForeign('beneficiarInn').length > 0
        ) {
          setShowTemplate(true);
        } else {
          setShowTemplate(false);
        }
      }
    }

    if (valuePageId === 'payment_budget') {
      if (
        getValuesBudget('amount') !== undefined &&
        getValuesBudget('amount') !== null &&
        getValuesBudget('amount').toString() !== '' &&
        getValuesBudget('desc').length > 0 &&
        getValuesBudget('fromAccount') !== undefined &&
        getValuesBudget('commission') !== undefined &&
        getValuesBudget('budgetAccNumber').length > 0 &&
        getValuesBudget('budgetAccNumber').length > 0 &&
        getValuesBudget('levelCode') !== undefined &&
        getValuesBudget('classCode').length > 0
      ) {
        setShowTemplate(true);
      } else {
        setShowTemplate(false);
      }
    }

    if (valuePageId === 'payment_edv') {
      if (
        getValuesEdv('amount') !== null &&
        getValuesEdv('amount').toString() !== '' &&
        getValuesEdv('desc').length > 0 &&
        getValuesEdv('fromAccount') !== undefined &&
        getValuesEdv('commission') !== undefined &&
        getValuesEdv('beneficiarVoen').length > 0 &&
        getValuesEdv('beneficiarName').length > 0
      ) {
        setShowTemplate(true);
      } else {
        setShowTemplate(false);
      }
    }

    if (valuePageId === 'payment_conversion') {
      if (individual) {
        if (
          getValuesConversion('amountFrom') !== null &&
          getValuesConversion('amountFrom') !== undefined &&
          getValuesConversion('amountFrom').toString() !== '' &&
          getValuesConversion('amountTo') !== null &&
          getValuesConversion('amountTo') !== undefined &&
          getValuesConversion('amountTo').toString() !== '' &&
          getValuesConversion('fromAccount') !== undefined &&
          getValuesConversion('toAccount') !== undefined &&
          getValuesConversion('commission') !== undefined &&
          getValuesConversion('customerRate') !== null &&
          getValuesConversion('customerRate') !== undefined &&
          getValuesConversion('customerRate').toString() !== ''
        ) {
          setShowTemplate(true);
        } else {
          setShowTemplate(false);
        }
      } else {
        if (
          getValuesConversion('amountFrom') !== null &&
          getValuesConversion('amountFrom') !== undefined &&
          getValuesConversion('amountFrom').toString() !== '' &&
          getValuesConversion('amountTo') !== null &&
          getValuesConversion('amountTo') !== undefined &&
          getValuesConversion('amountTo').toString() !== '' &&
          getValuesConversion('fromAccount') !== undefined &&
          getValuesConversion('toAccount') !== undefined &&
          getValuesConversion('commission') !== undefined
        ) {
          setShowTemplate(true);
        } else {
          setShowTemplate(false);
        }
      }
    }
  };

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    if (pageId === null || valuePageId === 'payment_acc2acc') {
      if (
        (getValues('amount') !== null && getValues('amount').toString() !== '') ||
        // getValues('desc').length > 0 ||
        getValues('fromAccount') !== undefined ||
        (getValues('toAccount') !== null && getValues('toAccount') !== undefined)
      ) {
        setCheckLeave(true);
      } else {
        handleLeavePage(newValue);
      }
    }

    if (valuePageId === 'payment_interbank') {
      if (
        (getValuesInBank('amount') !== null && getValuesInBank('amount').toString() !== '') ||
        getValuesInBank('desc').length > 0 ||
        selectedFromAccount !== undefined ||
        getValuesInBank('toAccount').length > 0 ||
        getValuesInBank('contractNumber').length > 0 ||
        fileInBank.length > 0 ||
        fileInBankArray.length > 0
      ) {
        setCheckLeave(true);
      } else {
        handleLeavePage(newValue);
      }
    }

    if (valuePageId === 'payment_local_transfer') {
      if (
        (getValuesLocalTransfer('amount') !== null && getValuesLocalTransfer('amount').toString() !== '') ||
        getValuesLocalTransfer('desc').length > 0 ||
        selectedFromAccount !== undefined ||
        (commission !== null && commission !== undefined) ||
        getValuesLocalTransfer('contractNumber').length > 0 ||
        (selectedOptions !== null && selectedOptions !== undefined) ||
        fileInBank.length > 0 ||
        fileInBankArray.length > 0 ||
        customerType !== undefined ||
        (getValuesLocalTransfer('bankCode') !== undefined && getValuesLocalTransfer('bankCode').length > 0) ||
        (getValuesLocalTransfer('beneficiarVoen') !== undefined &&
          getValuesLocalTransfer('beneficiarVoen').length > 0) ||
        (getValuesLocalTransfer('beneficiarName') !== undefined &&
          getValuesLocalTransfer('beneficiarName').length > 0) ||
        (getValuesLocalTransfer('beneficiarAccNo') !== undefined &&
          getValuesLocalTransfer('beneficiarAccNo').length > 0) ||
        (getValuesLocalTransfer('ipsValue') !== undefined && getValuesLocalTransfer('ipsValue').length > 0)
      ) {
        setCheckLeave(true);
      } else {
        handleLeavePage(newValue);
      }
    }
    if (valuePageId === 'payment_foreign_transfer') {
      if (
        (getValuesForeign('amount') !== null && getValuesForeign('amount').toString() !== '') ||
        getValuesForeign('desc').length > 0 ||
        selectedFromAccount !== undefined ||
        commission !== undefined ||
        getValuesForeign('contractNumber').length > 0 ||
        fileInBank.length > 0 ||
        fileInBankArray.length > 0 ||
        selectedCountries !== undefined ||
        getValuesForeign('swiftBic').length > 0 ||
        getValuesForeign('beneficiarAccNumber').length > 0 ||
        getValuesForeign('beneficiarName').length > 0 ||
        getValuesForeign('beneficiarAddress').length > 0 ||
        getValuesForeign('midBankSwiftBic').length > 0 ||
        getValuesForeign('midBankAccNumber').length > 0 ||
        getValuesForeign('invoiceNo').length > 0 ||
        getValuesForeign('beneficiarKpp').length > 0 ||
        getValuesForeign('beneficiarInn').length > 0
      ) {
        setCheckLeave(true);
      } else {
        handleLeavePage(newValue);
      }
    }

    if (valuePageId === 'payment_budget') {
      if (
        (getValuesBudget('amount') !== null && getValuesBudget('amount').toString() !== '') ||
        getValuesBudget('desc').length > 0 ||
        selectedFromAccount !== undefined ||
        commission !== undefined ||
        getValuesBudget('budgetAccNumber').length > 0 ||
        ibanField.length > 0 ||
        selectedBudgetLevelCodes !== undefined ||
        classCodeBudget.length > 0
      ) {
        setCheckLeave(true);
      } else {
        handleLeavePage(newValue);
      }
    }
    if (valuePageId === 'payment_edv') {
      if (
        (getValuesEdv('amount') !== null && getValuesEdv('amount').toString() !== '') ||
        getValuesEdv('desc').length > 0 ||
        selectedFromAccount !== undefined ||
        commission !== undefined ||
        getValuesEdv('beneficiarVoen').length > 0 ||
        getValuesEdv('beneficiarName').length > 0
      ) {
        setCheckLeave(true);
      } else {
        handleLeavePage(newValue);
      }
    }

    if (valuePageId === 'payment_conversion') {
      if (
        (getValuesConversion('amountFrom') !== null &&
          getValuesConversion('amountFrom') !== undefined &&
          getValuesConversion('amountFrom').toString() !== '') ||
        (getValuesConversion('amountTo') !== null &&
          getValuesConversion('amountTo') !== undefined &&
          getValuesConversion('amountTo').toString() !== '') ||
        (getValuesConversion('customerRate') !== null &&
          getValuesConversion('customerRate') !== undefined &&
          getValuesConversion('customerRate').toString() !== '') ||
        selectedFromAccountConversion !== undefined ||
        selectedToAccountConversion !== undefined ||
        selectedCommissionConversion !== undefined
      ) {
        setCheckLeave(true);
      } else {
        handleLeavePage(newValue);
      }
    }

    setPageName(newValue);
  };

  const handleLeavePage = (newValue?: any) => {
    if (newValue !== undefined && newValue !== null) {
      setValuePageId(newValue);
      navigate(`${lang}/transfer-page?type=${newValue}`);
      sendTransferTypeMutation({ businessKey: dataGetTransfer?.business_key, data: { transfer_type: newValue } });
    }
    setSelectedFromAccountTrigger(false);

    setValue('amount', null);
    setValue('desc', '');
    setValue('fromAccount', undefined);
    setSelectedFromAccount(undefined);
    setValue('toAccount', null);
    setSelectedToAccount(null);
    clearErrors('amount');
    clearErrors('desc');
    clearErrors('fromAccount');
    clearErrors('toAccount');
    setAmountValue('');
    setDisabledToAccount(true);

    setValueInBank('amount', null);
    setValueInBank('desc', '');
    setValueInBank('toAccount', '');
    setValueInBank('contractNumber', '');
    setValueInBank('fromAccount', undefined);
    setValueInBank('fileInBank', '');
    setValueInBank('customerType', '');
    setValueInBank('beneficiarName', '');
    setValueInBank('beneficiarVoen', '');
    setIbanField('');
    setFileInBank([]);
    setFileInBankArray([]);
    setErrorFileInBank(false);
    setContractNumberRequiredInBank('false');
    clearErrorsInBank('amount');
    clearErrorsInBank('desc');
    clearErrorsInBank('fromAccount');
    clearErrorsInBank('toAccount');
    clearErrorsInBank('contractNumber');
    clearErrorsInBank('fileInBank');

    setValueBudget('amount', null);
    setValueBudget('desc', '');
    setValueBudget('fromAccount', undefined);
    setCommission(undefined);
    setValueBudget('commission', undefined);
    setValueBudget('budgetAccNumber', '');
    setSelectedBudgetLevelCodes(undefined);
    setValueBudget('levelCode', undefined);
    setClassCodeBudget('');
    setBankCodeData([]);
    setValueBudget('classCode', '');
    setBudgetIban('');
    setValueBudget('orgName', '');
    setValueBudget('orgVoen', '');
    setValueBudget('className', '');
    clearErrorsBudget('amount');
    clearErrorsBudget('desc');
    clearErrorsBudget('fromAccount');
    clearErrorsBudget('commission');
    clearErrorsBudget('budgetAccNumber');
    clearErrorsBudget('levelCode');
    clearErrorsBudget('classCode');

    setValueEdv('amount', null);
    setValueEdv('desc', '');
    setValueEdv('fromAccount', undefined);
    setValueEdv('commission', undefined);
    setValueEdv('beneficiarVoen', '');
    setValueEdv('beneficiarName', '');
    clearErrorsEdv('amount');
    clearErrorsEdv('desc');
    clearErrorsEdv('fromAccount');
    clearErrorsEdv('commission');
    clearErrorsEdv('beneficiarVoen');
    clearErrorsEdv('beneficiarName');

    setValueConversion('customerRate', null);
    setValueConversion('fromAccount', undefined);
    setValueConversion('toAccount', undefined);
    setValueConversion('amountFrom', null);
    setValueConversion('amountTo', null);
    setValueConversion('commission', undefined);
    setSelectedFromAccountConversion(undefined);
    setSelectedToAccountConversion(undefined);
    setSelectedCommissionConversion(undefined);
    setFromAmountConversion('');
    setToAmountConversion('');
    clearErrorsConversion('commission');
    clearErrorsConversion('customerRate');
    clearErrorsConversion('fromAccount');
    clearErrorsConversion('toAccount');
    clearErrorsConversion('amountFrom');
    clearErrorsConversion('amountTo');
    setCheckIndividualConversion(false);

    setValueLocalTransfer('amount', null);
    setValueLocalTransfer('fromAccount', undefined);
    setValueLocalTransfer('commission', undefined);
    setValueLocalTransfer('paymentType', undefined);
    setSelectedOptions(undefined);
    setValueLocalTransfer('customerType', undefined);
    setCustomerType(undefined);
    setValueLocalTransfer('bankCode', '');
    setBankCodeValueLocal('');
    setValueLocalTransfer('bankName', '');
    setValueLocalTransfer('bankAccNumber', '');
    setSelfPayment(false);
    setValueLocalTransfer('beneficiarAccNo', '');
    setVoenLocal('');
    setBeneficiarNameLocal('');
    setBeneficiarIbanLocal('');
    setValueLocalTransfer('beneficiarVoen', '');
    setValueLocalTransfer('beneficiarName', '');
    setValueLocalTransfer('ipsValue', '');
    setValueLocalTransfer('ipsType', undefined);
    setValueLocalTransfer('contractNumber', '');
    setValueLocalTransfer('desc', '');
    clearErrorsLocalTransfer('amount');
    clearErrorsLocalTransfer('fromAccount');
    clearErrorsLocalTransfer('commission');
    clearErrorsLocalTransfer('paymentType');
    clearErrorsLocalTransfer('customerType');
    clearErrorsLocalTransfer('bankCode');
    clearErrorsLocalTransfer('beneficiarVoen');
    clearErrorsLocalTransfer('beneficiarName');
    clearErrorsLocalTransfer('beneficiarAccNo');
    clearErrorsLocalTransfer('desc');
    clearErrorsLocalTransfer('contractNumber');
    clearErrorsLocalTransfer('ipsType');
    clearErrorsLocalTransfer('ipsValue');

    setValueForeign('amount', null);
    setValueForeign('desc', '');
    setValueForeign('contractNumber', '');
    setValueForeign('invoiceNo', '');
    setValueForeign('fromAccount', undefined);
    setValueForeign('commission', undefined);
    setValueForeign('country', undefined);
    setSelectedCountries(undefined);
    setValueForeign('swiftBic', '');
    setValueForeign('beneficiarBankName', '');
    setBeneficiarNameForeign('');
    setValueForeign('beneficiarName', '');
    setValueForeign('beneficiarAccNumber', '');
    setBeneficiarAddressForeign('');
    setValueForeign('beneficiarAddress', '');
    setMediatorBank(false);
    setValueForeign('midBankAccNumber', '');
    setValueForeign('midBankSwiftBic', '');
    setValueForeign('midBankName', '');
    setValueForeign('beneficiarKpp', '');
    setValueForeign('beneficiarInn', '');
    setAvans(false);
    clearErrorsForeign('amount');
    clearErrorsForeign('desc');
    clearErrorsForeign('contractNumber');
    clearErrorsForeign('invoiceNo');
    clearErrorsForeign('fromAccount');
    clearErrorsForeign('commission');
    clearErrorsForeign('country');
    clearErrorsForeign('swiftBic');
    clearErrorsForeign('beneficiarName');
    clearErrorsForeign('beneficiarAccNumber');
    clearErrorsForeign('beneficiarAddress');
    clearErrorsForeign('midBankAccNumber');
    clearErrorsForeign('midBankSwiftBic');
    clearErrorsForeign('midBankName');
    clearErrorsForeign('beneficiarKpp');
    clearErrorsForeign('beneficiarInn');

    setCheckLeave(false);
  };

  const onChangeFromAccount = (newValue: any) => {
    setSelectedFromAccount(newValue);
    clearErrorsLocalTransfer('commission');
    handleCheckTemplateBtn();

    if (valuePageId === 'payment_acc2acc') {
      setValue('fromAccount', newValue);
      if (selectedFromAccountTrigger) {
        trigger('amount');
      }
    }

    if (valuePageId === 'payment_interbank') {
      setValueInBank('fromAccount', newValue);
      if (currencyOfToAccount?.length > 0) {
        triggerInBank('toAccount');
      }
      if (selectedFromAccountTrigger) {
        triggerInBank('amount');
      }
    }

    if (valuePageId === 'payment_local_transfer') {
      setValueLocalTransfer('commission', newValue);
      setCommission(newValue);
      if (selectedFromAccountTrigger) {
        triggerLocalTransfer('amount');
      }
    }

    if (valuePageId === 'payment_budget') {
      setValueBudget('commission', newValue);
      clearErrorsBudget('commission');
      setCommission(newValue);
      if (selectedFromAccountTrigger) {
        triggerBudget('amount');
      }
    }

    if (valuePageId === 'payment_edv') {
      setValueEdv('commission', newValue);
      clearErrorsEdv('commission');
      setCommission(newValue);
      if (selectedFromAccountTrigger) {
        triggerEdv('amount');
      }
    }

    if (valuePageId === 'payment_foreign_transfer') {
      setValueForeign('commission', newValue);
      clearErrorsForeign('commission');
      setCommission(newValue);
      if (selectedFromAccountTrigger) {
        triggerForeign('amount');
      }
    }
  };

  const onChangeToAccount = (newValue: any) => {
    setSelectedToAccount(newValue);
    handleCheckTemplateBtn();
  };

  const onChange = (newValue: any) => {
    if (newValue.value === 'AZIPS' || newValue.value === 'XOHKS') {
      setCustomerTypeIsRequired(true);
      setIpsIsRequired(false);
    } else if (newValue.value === 'IPS_MT') {
      setIpsIsRequired(true);
      setCustomerTypeIsRequired(false);
      setCustomerTypeVoenIsRequired(false);
    }
    setSelectedOptions(newValue);
    setCustomerType(null);
    setValueLocalTransfer('customerType', null);
    setValueLocalTransfer('ipsType', null);
    setValueLocalTransfer('ipsValue', '');
    setTaxEnabledLocal(false);
    setSelfPayment(false);
    setValueLocalTransfer('beneficiarVoen', '');
    setValueLocalTransfer('beneficiarName', '');
    setValueLocalTransfer('beneficiarAccNo', '');
    setValueLocalTransfer('bankCode', '');
    setValueLocalTransfer('bankName', '');
    setValueLocalTransfer('bankAccNumber', '');
    setBankCodeValueLocal('');
    handleCheckTemplateBtn();
  };

  const handleSwitchSelfPayment = () => {
    handleCheckTemplateBtn();
    setSelfPayment(!selfPayment);
    if (!selfPayment) {
      setValueLocalTransfer('beneficiarVoen', inn);
      setValueLocalTransfer('beneficiarName', title);
      clearErrorsLocalTransfer('beneficiarName');
      clearErrorsLocalTransfer('beneficiarVoen');
      if (dataSendTransferType === undefined) {
        setCustomerType(dataSendTransferTypeFromGetData?.customer_info?.customer_type);
        setValueLocalTransfer('customerType', dataSendTransferTypeFromGetData?.customer_info?.customer_type);
      } else {
        setCustomerType(dataSendTransferType?.customer_info?.customer_type);
        setValueLocalTransfer('customerType', dataSendTransferType?.customer_info?.customer_type);
      }
    } else {
      setValueLocalTransfer('beneficiarVoen', '');
      setValueLocalTransfer('beneficiarName', '');
      setCustomerType(null);
    }
  };

  const handleSwitchTaxEnabled = () => {
    setTaxEnabledLocal(!taxEnabledLocal);
  };

  // const confirmTransfer = () => {
  //   if (confirm) {
  //     setAsanConfirmation(true);
  //   } else {
  //     navigate(`${lang}/transfer-page?confirm=true`);
  //   }
  // };

  const handleChangeAmount = (e: any) => {
    const inputValue = e.target.value;
    const regex = new RegExp(/^[0-9]*\.?[0-9]*$/, '');

    if (regex.test(inputValue)) {
      setAmountValue(inputValue);
      handleCheckTemplateBtn();
    }
  };

  const handleChangeInvoiceNo = (e: any) => {
    const inputValue = e.target.value;
    const regex = new RegExp(/^[0-9]*$/, '');

    if (regex.test(inputValue)) {
      setInvoiceValue(inputValue);
    }
  };

  const handleOnChangeInBankToAccount = (e: any) => {
    const inputValue = e.target.value;
    const regex = new RegExp(/^[a-zA-Z0-9]*$/, '');
    // setCurrencyOfToAccount('');

    if (e.target.value.length === 28) {
      getBeneficiarMutation({
        businessKey: dataGetTransfer?.business_key,
        data: {
          cr_acc_no: e.target.value,
          action: 'check_customer',
        },
      });

      triggerInBank('toAccount');
    }

    if (e.target.value.length < 28) {
      setValueInBank('beneficiarName', '');
      setValueInBank('beneficiarVoen', '');
      setValueInBank('customerType', '');
      clearErrorsInBank('toAccount');
    }

    if (regex.test(inputValue)) {
      setIbanField(inputValue);
    }
  };

  const handleChangeLocalTransferBeneficiarCode = (e: any) => {
    const inputValue = e.target.value;
    const regex = new RegExp(/^[0-9]*$/, '');
    handleCheckTemplateBtn();

    if (regex.test(inputValue)) {
      setBankCodeValueLocal(inputValue);
      setValueLocalTransfer('bankCode', inputValue);

      if (inputValue.length === 6) {
        getBeneficiarDataLocalTransferMutation({
          businessKey: dataGetTransfer?.business_key,
          data: {
            search: inputValue,
            action: 'bank_code',
            popup: 'false',
          },
        });
      }

      if (inputValue.length < 6) {
        setValueLocalTransfer('bankName', '');
        setValueLocalTransfer('bankAccNumber', '');
      }
    }
  };

  const handleClickLocalTransferBankCode = (branchName: any, corrAcc: any, bankCode: any) => {
    setValueLocalTransfer('bankName', branchName);
    setValueLocalTransfer('bankAccNumber', corrAcc);
    setValueLocalTransfer('bankCode', bankCode);
    handleCheckTemplateBtn();

    setBankCodeValueLocal(bankCode);
  };

  const handleClickOrgCode = (orgName: any, code: any) => {
    setValueBudget('className', orgName);
    setValueBudget('classCode', code);

    setClassCodeBudget(code);
  };

  const handleClickSwiftCode = (bankName: any, code: any) => {
    setValueForeign('beneficiarBankName', bankName);
    setValueForeign('swiftBic', code);
    triggerForeign('swiftBic');
  };

  const handleSearchSwiftCode = useMemo(
    () =>
      debounce((e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.value.length === 0) {
          setValueForeign('beneficiarBankName', '');
        }
        getSwiftCodeMutation({
          businessKey: dataGetTransfer?.business_key,
          data: {
            search: e.target.value,
            offset: 0,
            name: `bank_bic`,
            bic_code: selectedCountries?.bicCode,
            currency: selectedFromAccount?.currency,
          },
        });
      }, 300),
    [selectedCountries, selectedFromAccount]
  );

  const handleSearchMediatorSwiftCode = useMemo(
    () =>
      debounce((e: React.ChangeEvent<HTMLInputElement>) => {
        getSwiftCodeMutation({
          businessKey: dataGetTransfer?.business_key,
          data: {
            search: e.target.value,
            offset: 0,
            name: 'bank_bic',
            bic_code: selectedCountries?.bicCode,
            currency: selectedFromAccount?.currency,
          },
        });
      }, 300),
    []
  );

  //   a-zA-Z0-9.~`"'?_,№:; -

  const handleChangeTextArea = (e: any) => {
    const inputValue = e.target.value;
    const regexForTextArea = /^[a-zA-Z0-9.,№:;\n -]*$/;
    const regexForTextAZE = /^[əƏöÖğĞıIüÜşŞçÇİa-zA-Z0-9.,№:;\n -]*$/;
    const regexForTextCyrillic = /^[ЁёА-я0-9.,№:;\n -]*$/;

    handleCheckTemplateBtn();

    if (
      pageId === null ||
      pageId === 'payment_acc2acc' ||
      pageId === 'payment_interbank' ||
      pageId === 'payment_local_transfer' ||
      pageId === 'payment_budget' ||
      pageId === 'payment_edv'
    ) {
      trigger('desc');
      triggerInBank('desc');
      triggerLocalTransfer('desc');
      triggerBudget('desc');
      triggerEdv('desc');
      if (regexForTextAZE.test(inputValue)) {
        setValueTextArea(inputValue);
      }
    } else if (pageId === 'payment_foreign_transfer' && selectedCountries?.value === 'RUS') {
      triggerForeign('desc');
      if (regexForTextCyrillic.test(inputValue)) {
        setValueTextArea(inputValue);
      }
    } else {
      triggerForeign('desc');
      if (regexForTextArea.test(inputValue)) {
        setValueTextArea(inputValue);
      }
    }
  };

  const handleClickMediatorSwiftCode = (bankName: any, code: any) => {
    setValueForeign('midBankName', bankName);
    setValueForeign('midBankSwiftBic', code);
    triggerForeign('midBankSwiftBic');
  };

  const [budgetIban, setBudgetIban] = useState('');

  const orgCodeChange = (e: any) => {
    const inputValue = e.target.value;
    const regex = new RegExp(/^[a-zA-Z0-9]*$/);

    handleCheckTemplateBtn();

    if (regex.test(inputValue)) {
      setBudgetIban(inputValue);
      if (e.target.value.length === 28) {
        getOrganizationMutation({
          businessKey: dataGetTransfer?.business_key,
          data: {
            search: e.target.value,
            limit: 30,
            offset: 0,
            name: 'organization',
            popup: 'false',
          },
        });
      }

      if (e.target.value.length < 28) {
        setValueBudget('orgName', '');
        setValueBudget('orgVoen', '');
      }
    }
  };

  const handleChangeCommissionLocalTransfer = (newValue: any) => {
    setCommission(newValue);
    setValueLocalTransfer('commission', newValue);
    handleCheckTemplateBtn();
  };

  const handleChangeCustomerType = (newValue: any) => {
    if (newValue.type === '2') {
      setCustomerTypeVoenIsRequired(true);
      setFileRequiredLocal(false);
    } else {
      setCustomerTypeVoenIsRequired(false);
      setFileRequiredLocal(true);
      if (selectedFromAccountTrigger) {
        triggerLocalTransfer('beneficiarVoen');
      }
      setVoenLocal('');
      setValueLocalTransfer('beneficiarVoen', '');
    }

    setCustomerType(newValue);
    handleCheckTemplateBtn();
  };

  const handleChangeSelectedBudgetValue = (newValue: any) => {
    setSelectedBudgetLevelCodes(newValue);
    handleCheckTemplateBtn();
  };

  const handleDeleteInBankFile = (index: any) => {
    setFileInBank(fileInBank.filter((_: any, i: any) => i !== index));
    setFileInBankArray(fileInBankArray.filter((_: any, i: any) => i !== index));
    if (fileInBank.length === 1) {
      setValueForeign('fileInBank', []);
    }
  };

  const handleChangeBudgetClassCode = (e: any) => {
    const inputValue = e.target.value;
    const cleanedValue = inputValue.replace(/[^\d]/g, '');

    handleCheckTemplateBtn();

    if (cleanedValue.length === 6) {
      getClassificationMutation({
        businessKey: dataGetTransfer?.business_key,
        data: {
          search: cleanedValue,
          offset: 0,
          popup: 'false',
        },
      });
    }

    if (cleanedValue.length < 6) {
      setValueBudget('className', '');
    }

    setClassCodeBudget(cleanedValue);
  };

  const handleChangeIpsValueInput = (e: any) => {
    setIpsValueInput(e.target.value);
  };

  const handleSearchIps = () => {
    getIpsDataMutation({
      businessKey: dataGetTransfer?.business_key,
      data: {
        action: 'validate_ips_alias',
        value: ipsValueInput,
        type: customerType?.code,
        transfer_type: 'payment_ips',
      },
    });
  };

  const handleChangeFromConversion = (newValue: any) => {
    setSelectedFromAccountConversion(newValue);
    if (selectedFromAccountTrigger) {
      triggerConversion('amountFrom');
    }

    handleCheckTemplateBtn();

    if (newValue.currency === 'AZN') {
      setToAccountConversion(optionsConversion.filter((item: any) => item.currency !== 'AZN'));
    }

    if (newValue.currency !== 'AZN') {
      setToAccountConversion(optionsConversion.filter((item: any) => item.currency === 'AZN'));
      handleChangeFromAmountConversion(
        { target: { value: fromAmountConversion } },
        newValue,
        selectedToAccountConversion
      );
    }
  };

  const handleChangeToConversion = (newValue: any) => {
    setSelectedToAccountConversion(newValue);

    handleCheckTemplateBtn();

    if (newValue.currency === 'AZN') {
      setFromAccountConversion(optionsConversion.filter((item: any) => item.currency !== 'AZN'));
    }

    if (newValue.currency !== 'AZN') {
      setFromAccountConversion(optionsConversion.filter((item: any) => item.currency === 'AZN'));
      handleChangeFromAmountConversion(
        { target: { value: fromAmountConversion } },
        selectedFromAccountConversion,
        newValue
      );
    }
  };

  const handleChangeCommissionConversion = (newValue: any) => {
    setSelectedCommissionConversion(newValue);
    handleCheckTemplateBtn();
  };

  const handleSwitchIndividualConversion = () => {
    setCheckIndividualConversion(!checkIndividualConversion);
    setIndividualRates('');

    handleCheckTemplateBtn(!checkIndividualConversion);
  };

  useEffect(() => {
    if (!checkIndividualConversion) {
      handleChangeFromAmountConversion(
        { target: { value: fromAmountConversion } },
        selectedFromAccountConversion,
        selectedToAccountConversion,
        undefined
      );
    }
  }, [checkIndividualConversion]);

  const handleSelectRates = (newValue: any) => {
    setSelectedRates(newValue);
  };

  const [individualRates, setIndividualRates] = useState('');

  const handleChangeIndividualRate = (e: any) => {
    if (e.target.value === '' || onlyDigit.test(e.target.value)) {
      setIndividualRates(e.target.value);
      setValueConversion('customerRate', e.target.value);
      handleCheckTemplateBtn();
      handleChangeFromAmountConversion(
        { target: { value: fromAmountConversion } },
        undefined,
        undefined,
        e.target.value
      );

      logger.log('buy');
      logger.log(+rates.find((item: any) => item.value === selectedFromAccountConversion?.currency).buy);
      logger.log('sell');
      logger.log(+rates.find((item: any) => item.value === selectedToAccountConversion?.currency).sell);
      logger.log('individual');
      logger.log(e.target.value);

      if (
        selectedFromAccountConversion.currency !== 'AZN' &&
        +e.target.value === +rates.find((item: any) => item.value === selectedFromAccountConversion?.currency).buy
      ) {
        setCheckIndividualConversion(false);
        setIndividualRates('');
      }
      if (
        selectedFromAccountConversion.currency === 'AZN' &&
        +e.target.value === +rates.find((item: any) => item.value === selectedToAccountConversion?.currency).sell
      ) {
        logger.log('in change');
        setCheckIndividualConversion(false);
        setIndividualRates('');
      }
    }
  };

  const handleChangeFromAmountConversion = (e: any, from?: any, to?: any, individual?: any) => {
    let amount: string;

    if (selectedFromAccountConversion === undefined && selectedToAccountConversion === undefined) {
      return false;
    } else if (selectedFromAccountConversion !== undefined && selectedToAccountConversion === undefined) {
      return false;
    } else if (selectedFromAccountConversion === undefined && selectedToAccountConversion !== undefined) {
      return false;
    } else {
      if (e.target.value === '' || onlyDigit.test(e.target.value)) {
        amount = e.target.value;

        let newAmount: number;

        if (checkIndividualConversion && individual !== undefined) {
          newAmount = +amount * +individual;
        } else if (checkIndividualConversion && individual === undefined) {
          newAmount = +amount * +individualRates;
        } else if (from === undefined) {
          if (selectedFromAccountConversion.currency !== 'AZN') {
            newAmount = +amount * rates.find((item: any) => item.value === selectedFromAccountConversion?.currency).buy;
          }
          if (selectedFromAccountConversion.currency === 'AZN') {
            newAmount = +amount / rates.find((item: any) => item.value === selectedToAccountConversion?.currency).sell;
          }
        } else {
          if (from.currency !== 'AZN') {
            newAmount = +amount * rates.find((item: any) => item.value === from?.currency).buy;
          }
          if (from.currency === 'AZN') {
            newAmount = +amount / rates.find((item: any) => item.value === to?.currency).sell;
          }
        }

        setFromAmountConversion(amount);
        setValueConversion('amountFrom', +amount);

        if (amount === undefined || amount.length === 0) {
          setToAmountConversion('');
          setValueConversion('amountTo', null);
        } else {
          setToAmountConversion(newAmount.toFixed(2).toString());
          setValueConversion('amountTo', +newAmount.toFixed(2));
        }
      }
    }

    handleCheckTemplateBtn();
  };

  const handleChangeToAmountConversion = (e: any) => {
    let amount: string;

    if (selectedFromAccountConversion === undefined && selectedToAccountConversion === undefined) {
      return false;
    } else if (selectedFromAccountConversion !== undefined && selectedToAccountConversion === undefined) {
      return false;
    } else if (selectedFromAccountConversion === undefined && selectedToAccountConversion !== undefined) {
      return false;
    } else {
      if (e.target.value === '' || onlyDigit.test(e.target.value)) {
        amount = e.target.value;

        let newAmount: number;

        if (checkIndividualConversion) {
          newAmount = +amount * +individualRates;
        } else if (selectedToAccountConversion.currency !== 'AZN') {
          newAmount = +amount * rates.find((item: any) => item.value === selectedToAccountConversion?.currency).sell;
        } else if (selectedToAccountConversion.currency === 'AZN') {
          newAmount = +amount / rates.find((item: any) => item.value === selectedFromAccountConversion?.currency).buy;
        }

        setToAmountConversion(amount);
        setValueConversion('amountTo', +amount);

        if (amount === undefined || amount.length === 0) {
          setFromAmountConversion('');
          setValueConversion('amountFrom', null);
        } else {
          setFromAmountConversion(newAmount.toFixed(2).toString());
          setValueConversion('amountFrom', +newAmount.toFixed(2));
          if (selectedFromAccountTrigger) {
            triggerConversion('amountFrom');
          }
        }
      }
    }

    handleCheckTemplateBtn();
  };

  const handleSwitchCurrencyConversion = () => {
    setSelectedFromAccountConversion(selectedToAccountConversion);
    setValueConversion('fromAccount', selectedToAccountConversion);
    if (selectedFromAccountTrigger) {
      triggerConversion('amountFrom');
    }

    setFromAccountConversion(toAccountConversion);
    setToAccountConversion(fromAccountConversion);
    setSelectedToAccountConversion(selectedFromAccountConversion);
    setValueConversion('toAccount', selectedFromAccountConversion);
    handleChangeFromAmountConversion(
      { target: { value: toAmountConversion } },
      selectedToAccountConversion,
      selectedFromAccountConversion
    );
  };

  const handleChangeCountry = (newValue: any) => {
    setSelectedCountries(newValue);
    setValueTextArea('');
    handleCheckTemplateBtn();
    if (newValue.value === 'RUS') {
      setMediatorBank(false);
    }
  };

  const handleSwitchMediatorBank = () => {
    setMediatorBank(!mediatorBank);
    if (selectedFromAccountTrigger) {
      triggerForeign('midBankSwiftBic');
      triggerForeign('midBankAccNumber');
    }
  };

  const handleSwitchAvans = () => {
    setAvans(!avans);
    handleCheckTemplateBtn(!avans);
  };

  const [voenEdv, setVoenEdv] = useState('');
  const [beneficiarNameEdv, setBeneficiarNameEdv] = useState('');

  const handleChangeVoenEdv = (e: any) => {
    const inputValue = e.target.value;
    const regex = new RegExp(/^[0-9]*$/);

    handleCheckTemplateBtn();

    if (regex.test(inputValue)) {
      setVoenEdv(inputValue);
    }
  };

  const handleChangeBeneficiarNameEdv = (e: any) => {
    const inputValue = e.target.value;
    const regex = new RegExp(/^[əƏöÖğĞıIüÜşŞçÇİa-zA-Z0-9.~`"'/?_,№:;\n -]*$/);

    handleCheckTemplateBtn();

    if (regex.test(inputValue)) {
      setBeneficiarNameEdv(inputValue);
    }
  };

  const [kppForeign, setKppForeign] = useState('');
  const [innForeign, setInnForeign] = useState('');
  const [beneficiarNameForeign, setBeneficiarNameForeign] = useState('');
  const [beneficiarAddressForeign, setBeneficiarAddressForeign] = useState('');

  const handleChangeKppForeign = (e: any) => {
    const inputValue = e.target.value;
    const regex = new RegExp(/^[0-9]*$/, '');

    if (regex.test(inputValue)) {
      setKppForeign(inputValue);
      handleCheckTemplateBtn();
    }
  };

  const handleChangeInnForeign = (e: any) => {
    const inputValue = e.target.value;
    const regex = new RegExp(/^[0-9]*$/, '');

    if (regex.test(inputValue)) {
      setInnForeign(inputValue);
      handleCheckTemplateBtn();
    }
  };

  const handleChangeBeneficiarNameForeign = (e: any) => {
    const inputValue = e.target.value;
    const regexCyrillic = new RegExp(/^[ЁёА-я0-9.~`"'/?_,№:;\n -]*$/, '');
    const regexLatin = new RegExp(/^[a-zA-Z0-9.~`"'?_,№:;\n -]*$/, '');

    if (selectedCountries?.value === 'RUS') {
      if (regexCyrillic.test(inputValue)) {
        setBeneficiarNameForeign(inputValue);
        handleCheckTemplateBtn();
      }
    }

    if (selectedCountries?.value !== 'RUS') {
      if (regexLatin.test(inputValue)) {
        setBeneficiarNameForeign(inputValue);
        handleCheckTemplateBtn();
      }
    }
  };

  const handleChangeBeneficiarAddressForeign = (e: any) => {
    const inputValue = e.target.value;
    const regexCyrillic = new RegExp(/^[ЁёА-я0-9.~`"'/?_,№:;\n -]*$/, '');
    const regexLatin = new RegExp(/^[a-zA-Z0-9.~`"'/?_,№:;\n -]*$/, '');

    if (selectedCountries?.value === 'RUS') {
      if (regexCyrillic.test(inputValue)) {
        setBeneficiarAddressForeign(inputValue);
        handleCheckTemplateBtn();
      }
    }

    if (selectedCountries?.value !== 'RUS') {
      if (regexLatin.test(inputValue)) {
        setBeneficiarAddressForeign(inputValue);
        handleCheckTemplateBtn();
      }
    }
  };

  const [voenLocal, setVoenLocal] = useState('');
  const [beneficiarNameLocal, setBeneficiarNameLocal] = useState('');
  const [beneficiarIbanLocal, setBeneficiarIbanLocal] = useState('');

  useEffect(() => {
    if (selfPayment) {
      setVoenLocal(inn);
      setBeneficiarNameLocal(title);
      setFileRequiredLocal(false);
    } else if (!selfPayment && (templateData === null || templateData === undefined)) {
      setVoenLocal('');
      setBeneficiarNameLocal('');
    }
  }, [selfPayment]);

  useEffect(() => {
    if (selectedFromAccountTrigger) {
      triggerLocalTransfer('fileInBank');
    }
  }, [fileRequiredLocal]);

  const handleChangeVoenLocal = (e: any) => {
    const inputValue = e.target.value;
    const regex = new RegExp(/^[0-9]*$/);

    if (regex.test(inputValue)) {
      setVoenLocal(inputValue);
    }

    handleCheckTemplateBtn();
  };

  const handleChangeBeneficiarNameLocal = (e: any) => {
    const inputValue = e.target.value;
    const regex = new RegExp(/^[əƏöÖğĞıIüÜşŞçÇİa-zA-Z0-9.~`"'?_,№:;\n -]*$/);

    if (regex.test(inputValue)) {
      setBeneficiarNameLocal(inputValue);
      handleCheckTemplateBtn();
    }
  };

  const handleChangeBeneficiarIbanLocal = (e: any) => {
    const inputValue = e.target.value;
    const regex = new RegExp(/^[a-zA-Z0-9]*$/);

    if (regex.test(inputValue)) {
      setBeneficiarIbanLocal(inputValue);
      handleCheckTemplateBtn();
    }
  };

  const submitForm = (data: any) => {
    if (selectedToAccount !== null) {
      if (selectedFromAccount.currency !== selectedToAccount.currency) {
        setOpenAlertModal(true);
      } else {
        acc2accMutation({
          businessKey: dataGetTransfer?.business_key,
          data: {
            db_acc_no: selectedFromAccount.value,
            cr_acc_no: selectedToAccount.value,
            amount: data.amount,
            description: data.desc,
          },
        });
      }
    }
  };

  const submitFormInBank = (data: any) => {
    acc2accMutation({
      businessKey: dataGetTransfer?.business_key,
      data: {
        db_acc_no: selectedFromAccount.value,
        cr_acc_no: data.toAccount,
        amount: data.amount,
        description: data.desc,
        contract_no: data.contractNumber,
        files: fileInBankArray,
      },
    });
  };

  const submitFormLocalTransfer = (data: any) => {
    if (selectedOptions.value === 'XOHKS' || selectedOptions.value === 'AZIPS') {
      acc2accMutation({
        businessKey: dataGetTransfer?.business_key,
        data: {
          customer_type_id: customerType.id,
          branch_code: bankCodeValueLocal,
          cr_acc_no: data.beneficiarAccNo,
          cr_name: data.beneficiarName,
          cr_tax_no: data.beneficiarVoen,
          db_acc_no: selectedFromAccount.value,
          com_acc_no: commission.value,
          tax_enabled: taxEnabledLocal,
          files: fileInBankArray,
          contract_no: data.contractNumber,
          description: data.desc,
          amount: data.amount,
          transfer_subtype: selectedOptions.value,
        },
      });
    }
  };

  const submitFormForeign = (data: any) => {
    if (selectedCountries.value !== 'RUS') {
      acc2accMutation({
        businessKey: dataGetTransfer?.business_key,
        data: {
          db_acc_no: selectedFromAccount.value,
          country_code: selectedCountries.value,
          cr_acc_no: data.beneficiarAccNumber,
          bank_bic_code: data.swiftBic,
          cr_name: data.beneficiarName,
          cr_address: data.beneficiarAddress,
          amount: data.amount,
          description: data.desc,
          contract_no: data.contractNumber,
          files: fileInBankArray,
          prepaid: avans,
          invoice_no: data.invoiceNo,
          com_acc_no: commission.value,
          int_acc_no: data.midBankAccNumber,
          int_bank: data.midBankSwiftBic,
        },
      });
    }

    if (selectedCountries.value === 'RUS') {
      acc2accMutation({
        businessKey: dataGetTransfer?.business_key,
        data: {
          db_acc_no: selectedFromAccount.value,
          country_code: selectedCountries.value,
          cr_acc_no: data.beneficiarAccNumber,
          bank_bic_code: data.swiftBic,
          cr_name: data.beneficiarName,
          cr_address: data.beneficiarAddress,
          amount: data.amount,
          description: data.desc,
          contract_no: data.contractNumber,
          files: fileInBankArray,
          prepaid: avans,
          invoice_no: data.invoiceNo,
          com_acc_no: commission.value,
          ru_inn: data.beneficiarInn,
          ru_kpp: data.beneficiarKpp,
        },
      });
    }
  };

  const submitFormEdv = (data: any) => {
    acc2accMutation({
      businessKey: dataGetTransfer?.business_key,
      data: {
        db_acc_no: selectedFromAccount.value,
        com_acc_no: commission.value,
        amount: data.amount,
        cr_tax_no: data.beneficiarVoen,
        cr_name: data.beneficiarName,
        description: data.desc,
        cr_acc_no: data.beneficiarAccNumber,
      },
    });
  };

  const submitFormBudget = (data: any) => {
    acc2accMutation({
      businessKey: dataGetTransfer?.business_key,
      data: {
        db_acc_no: selectedFromAccount.value,
        com_acc_no: commission.value,
        amount: data.amount,
        cr_acc_no: data.budgetAccNumber,
        organization: data.orgName,
        classification_code: data.classCode,
        level_code: selectedBudgetLevelCodes.value,
        description: data.desc,
      },
    });
  };

  const submitFormConversion = (data: any) => {
    if (checkIndividualConversion) {
      acc2accMutation({
        businessKey: dataGetTransfer?.business_key,
        data: {
          db_acc_no: selectedFromAccountConversion.value,
          com_acc_no: selectedCommissionConversion.value,
          amount: fromAmountConversion,
          cr_acc_no: selectedToAccountConversion.value,
          customer_rate: data.customerRate,
        },
      });
    } else {
      acc2accMutation({
        businessKey: dataGetTransfer?.business_key,
        data: {
          db_acc_no: selectedFromAccountConversion.value,
          com_acc_no: selectedCommissionConversion.value,
          amount: fromAmountConversion,
          cr_acc_no: selectedToAccountConversion.value,
        },
      });
    }
  };

  const [templateName, setTemplateName] = useState('');

  const handleChangeTemplateName = (e: any) => {
    setTemplateName(e.target.value);
  };

  const handleSaveTemplate = () => {
    if (pageId === null || pageId === 'payment_acc2acc') {
      createTemplateMutation({
        amount: amountValue,
        transfer_type: pageId === null ? 'payment_acc2acc' : pageId,
        title: templateName,
        content_data: {
          fromAccount: selectedFromAccount,
          toAccount: selectedToAccount,
          desc: getValues('desc'),
        },
      });
    }

    if (pageId === 'payment_interbank') {
      createTemplateMutation({
        amount: amountValue,
        transfer_type: pageId,
        title: templateName,
        content_data: {
          fromAccount: selectedFromAccount,
          toAccount: getValuesInBank('toAccount'),
          desc: getValuesInBank('desc'),
          contractNo: getValuesInBank('contractNumber'),
          files: fileInBankArray,
          filesData: fileInBank.map((item: any) => {
            return {
              name: item.name,
              size: item.size,
            };
          }),
          customerType: getValuesInBank('customerType'),
          beneficiarName: getValuesInBank('beneficiarName'),
          beneficiarVoen: getValuesInBank('beneficiarVoen'),
        },
      });
    }

    if (pageId === 'payment_edv') {
      createTemplateMutation({
        amount: amountValue,
        transfer_type: pageId,
        title: templateName,
        content_data: {
          fromAccount: selectedFromAccount,
          toAccount: getValuesEdv('beneficiarAccNumber'),
          beneficiarVoen: getValuesEdv('beneficiarVoen'),
          beneficiarName: getValuesEdv('beneficiarName'),
          comission: commission,
          desc: getValuesEdv('desc'),
        },
      });
    }

    if (pageId === 'payment_budget') {
      createTemplateMutation({
        amount: amountValue,
        transfer_type: pageId,
        title: templateName,
        content_data: {
          fromAccount: selectedFromAccount,
          toAccount: getValuesBudget('budgetAccNumber'),
          organization: getValuesBudget('orgName'),
          orgVoen: getValuesBudget('orgVoen'),
          classification_code: getValuesBudget('classCode'),
          classification_name: getValuesBudget('className'),
          level_code: selectedBudgetLevelCodes,
          comission: commission,
          desc: getValuesBudget('desc'),
        },
      });
    }

    if (pageId === 'payment_conversion') {
      createTemplateMutation({
        amount: fromAmountConversion,
        transfer_type: pageId,
        title: templateName,
        content_data: {
          fromAccount: selectedFromAccountConversion,
          toAccount: selectedToAccountConversion,
          fromAmount: getValuesConversion('amountFrom'),
          toAmount: getValuesConversion('amountTo'),
          comission: selectedCommissionConversion,
          customerRate: getValuesConversion('customerRate'),
          individual: checkIndividualConversion,
          rates,
        },
      });
    }

    if (pageId === 'payment_local_transfer') {
      createTemplateMutation({
        amount: amountValue,
        transfer_type: pageId,
        title: templateName,
        content_data: {
          fromAccount: selectedFromAccount,
          comission: commission,
          transferSubType: selectedOptions,
          customerType,
          branchCode: bankCodeValueLocal,
          beneficiarBankName: getValuesLocalTransfer('bankName'),
          beneficiarBankAcNo: getValuesLocalTransfer('bankAccNumber'),
          beneficiarVoen: getValuesLocalTransfer('beneficiarVoen'),
          beneficiarName: getValuesLocalTransfer('beneficiarName'),
          beneficiarAccNo: getValuesLocalTransfer('beneficiarAccNo'),
          contractNo: getValuesLocalTransfer('contractNumber'),
          desc: getValuesLocalTransfer('desc'),
          files: fileInBankArray,
          taxEnabled: taxEnabledLocal,
          selfPayment,
          filesData: fileInBank.map((item: any) => {
            return {
              name: item.name,
              size: item.size,
            };
          }),
        },
      });
    }

    if (pageId === 'payment_foreign_transfer') {
      createTemplateMutation({
        amount: amountValue,
        transfer_type: pageId,
        title: templateName,
        content_data: {
          fromAccount: selectedFromAccount,
          comission: commission,
          country: selectedCountries,
          beneficiarSwift: getValuesForeign('swiftBic'),
          beneficiarBankName: getValuesForeign('beneficiarBankName'),
          beneficiarAccNo: getValuesForeign('beneficiarAccNumber'),
          beneficiarName: getValuesForeign('beneficiarName'),
          beneficiarAddress: getValuesForeign('beneficiarAddress'),
          switchSwift: mediatorBank,
          middleSwiftBic: getValuesForeign('midBankSwiftBic'),
          midBankName: getValuesForeign('midBankName'),
          midBankAccNumber: getValuesForeign('midBankAccNumber'),
          kpp: getValuesForeign('beneficiarKpp'),
          inn: getValuesForeign('beneficiarInn'),
          avans,
          invoiceNo: getValuesForeign('invoiceNo'),
          contractNo: getValuesForeign('contractNumber'),
          desc: getValuesForeign('desc'),
          files: fileInBankArray,
          filesData: fileInBank.map((item: any) => {
            return {
              name: item.name,
              size: item.size,
            };
          }),
        },
      });
    }
  };

  const handleEditTemplate = () => {
    if (pageId === null || pageId === 'payment_acc2acc') {
      editTemplateMutation({
        id: templateId,
        amount: amountValue,
        transfer_type: pageId === null ? 'payment_acc2acc' : pageId,
        title: templateData.title,
        content_data: {
          fromAccount: selectedFromAccount,
          toAccount: selectedToAccount,
          desc: getValues('desc'),
        },
      });
    }

    if (pageId === 'payment_interbank') {
      editTemplateMutation({
        id: templateId,
        amount: amountValue,
        transfer_type: pageId,
        title: templateData.title,
        content_data: {
          fromAccount: selectedFromAccount,
          toAccount: getValuesInBank('toAccount'),
          desc: getValuesInBank('desc'),
          contractNo: getValuesInBank('contractNumber'),
          files: fileInBankArray,
          filesData: fileInBank.map((item: any) => {
            return {
              name: item.name,
              size: item.size,
            };
          }),
          customerType: getValuesInBank('customerType'),
          beneficiarName: getValuesInBank('beneficiarName'),
          beneficiarVoen: getValuesInBank('beneficiarVoen'),
        },
      });
    }

    if (pageId === 'payment_edv') {
      editTemplateMutation({
        id: templateId,
        amount: amountValue,
        transfer_type: pageId,
        title: templateData.title,
        content_data: {
          fromAccount: selectedFromAccount,
          toAccount: getValuesEdv('beneficiarAccNumber'),
          beneficiarVoen: getValuesEdv('beneficiarVoen'),
          beneficiarName: getValuesEdv('beneficiarName'),
          comission: commission,
          desc: getValuesEdv('desc'),
        },
      });
    }

    if (pageId === 'payment_budget') {
      editTemplateMutation({
        id: templateId,
        amount: amountValue,
        transfer_type: pageId,
        title: templateData.title,
        content_data: {
          fromAccount: selectedFromAccount,
          toAccount: getValuesBudget('budgetAccNumber'),
          organization: getValuesBudget('orgName'),
          orgVoen: getValuesBudget('orgVoen'),
          classification_code: getValuesBudget('classCode'),
          classification_name: getValuesBudget('className'),
          level_code: selectedBudgetLevelCodes,
          comission: commission,
          desc: getValuesBudget('desc'),
        },
      });
    }

    if (pageId === 'payment_conversion') {
      editTemplateMutation({
        id: templateId,
        amount: fromAmountConversion,
        transfer_type: pageId,
        title: templateData.title,
        content_data: {
          fromAccount: selectedFromAccountConversion,
          toAccount: selectedToAccountConversion,
          fromAmount: getValuesConversion('amountFrom'),
          toAmount: getValuesConversion('amountTo'),
          comission: selectedCommissionConversion,
          customerRate: getValuesConversion('customerRate') === null ? '' : getValuesConversion('customerRate'),
          individual: checkIndividualConversion,
          rates,
        },
      });
    }

    if (pageId === 'payment_local_transfer') {
      editTemplateMutation({
        id: templateId,
        amount: amountValue,
        transfer_type: pageId,
        title: templateData.title,
        content_data: {
          fromAccount: selectedFromAccount,
          comission: commission,
          transferSubType: selectedOptions,
          customerType,
          branchCode: bankCodeValueLocal,
          beneficiarBankName: getValuesLocalTransfer('bankName'),
          beneficiarBankAcNo: getValuesLocalTransfer('bankAccNumber'),
          beneficiarVoen: getValuesLocalTransfer('beneficiarVoen'),
          beneficiarName: getValuesLocalTransfer('beneficiarName'),
          beneficiarAccNo: getValuesLocalTransfer('beneficiarAccNo'),
          contractNo: getValuesLocalTransfer('contractNumber'),
          desc: getValuesLocalTransfer('desc'),
          files: fileInBankArray,
          taxEnabled: taxEnabledLocal,
          selfPayment,
          filesData: fileInBank.map((item: any) => {
            return {
              name: item.name,
              size: item.size,
            };
          }),
        },
      });
    }

    if (pageId === 'payment_foreign_transfer') {
      editTemplateMutation({
        id: templateId,
        amount: amountValue,
        transfer_type: pageId,
        title: templateData.title,
        content_data: {
          fromAccount: selectedFromAccount,
          comission: commission,
          country: selectedCountries,
          beneficiarSwift: getValuesForeign('swiftBic'),
          beneficiarBankName: getValuesForeign('beneficiarBankName'),
          beneficiarAccNo: getValuesForeign('beneficiarAccNumber'),
          beneficiarName: getValuesForeign('beneficiarName'),
          beneficiarAddress: getValuesForeign('beneficiarAddress'),
          switchSwift: mediatorBank,
          middleSwiftBic: getValuesForeign('midBankSwiftBic'),
          midBankName: getValuesForeign('midBankName'),
          midBankAccNumber: getValuesForeign('midBankAccNumber'),
          kpp: getValuesForeign('beneficiarKpp'),
          inn: getValuesForeign('beneficiarInn'),
          avans,
          invoiceNo: getValuesForeign('invoiceNo'),
          contractNo: getValuesForeign('contractNumber'),
          desc: getValuesForeign('desc'),
          files: fileInBankArray,
          filesData: fileInBank.map((item: any) => {
            return {
              name: item.name,
              size: item.size,
            };
          }),
        },
      });
    }
  };

  return {
    valuePageId,
    confirm,
    handleChange,
    selectedOptions,
    saveTemplate,
    setSaveTemplate,
    onChange,
    dataGetTransfer,
    isLoadingGetDataTransfer,
    handleSubmit,
    submitForm,
    fromAccount,
    onChangeFromAccount,
    selectedFromAccount,
    control,
    register,
    toAccount,
    onChangeToAccount,
    selectedToAccount,
    disabledToAccount,
    errors,
    openAlertModal,
    setOpenAlertModal,
    handleSubmitInBank,
    registerInBank,
    controlInBank,
    errorsInBank,
    handleOnChangeInBankToAccount,
    dataGetBeneficiar,
    onDropInBank,
    fileInBank,
    setFileInBank,
    handleSubmitLocalTransfer,
    registerLocalTransfer,
    controlLocalTransfer,
    errorsLocalTransfer,
    onDropLocalTransfer,
    fileLocalTransfer,
    commission,
    handleChangeCommissionLocalTransfer,
    errorFileInBank,
    getValuesInBank,
    countryOptions,
    customerType,
    handleChangeCustomerType,
    handleChangeLocalTransferBeneficiarCode,
    handleDeleteInBankFile,
    openBankCodeLocalTransferDialog,
    setOpenBankCodeLocalTransferDialog,
    dataGetBeneficiarDataLocalTransfer,
    bankCodeData,
    getBeneficiarDataLocalTransferMutation,
    handleClickLocalTransferBankCode,
    setIsSearchLocalTransfer,
    handleSwitchSelfPayment,
    selfPayment,
    submitFormInBank,
    isLoadingGetBeneficiar,
    isLoadingFileUpload,
    ipsValueInput,
    handleChangeIpsValueInput,
    dataGetIpsData,
    handleSearchIps,
    handleSubmitEdv,
    controlEdv,
    getValuesEdv,
    setValueEdv,
    errorsEdv,
    registerEdv,
    dataSendTransferType,
    registerBudget,
    controlBudget,
    handleSubmitBudget,
    getValuesBudget,
    setValueBudget,
    errorsBudget,
    budgetLevelCodes,
    handleChangeSelectedBudgetValue,
    selectedBudgetLevelCodes,
    openBudgetOrgDialog,
    setOpenBudgetOrgDialog,
    getClassificationMutation,
    handleClickOrgCode,
    orgCodeChange,
    registerConversion,
    errorsConversion,
    controlConversion,
    fromAccountConversion,
    toAccountConversion,
    handleChangeFromConversion,
    handleChangeToConversion,
    handleChangeCommissionConversion,
    selectedToAccountConversion,
    selectedFromAccountConversion,
    selectedCommissionConversion,
    checkIndividualConversion,
    handleSwitchIndividualConversion,
    rates,
    selectedRates,
    handleSelectRates,
    handleChangeFromAmountConversion,
    fromAmountConversion,
    toAmountConversion,
    handleChangeToAmountConversion,
    handleSwitchCurrencyConversion,
    isLoadingSendTransferType,
    isLoadingSendTransferTypeFromGetData,
    controlForeign,
    registerForeign,
    errorsForeign,
    countries,
    handleSubmitForeign,
    selectedCountries,
    handleChangeCountry,
    mediatorBank,
    handleSwitchMediatorBank,
    avans,
    handleSwitchAvans,
    fileForeign,
    onDropForeignTransfer,
    getValuesForeign,
    getValuesLocalTransfer,
    openSwiftBicCode,
    setOpenSwiftBicCode,
    openMediatorSwiftBicCode,
    setOpenMediatorSwiftBicCode,
    handleClickSwiftCode,
    getSwiftCodeMutation,
    handleClickMediatorSwiftCode,
    submitFormForeign,
    openSnackbar,
    setOpenSnackBar,
    dataAcc2acc,
    isLoadingAcc2acc,
    submitFormEdv,
    submitFormBudget,
    bankCodeValueLocal,
    handleSearchMediatorSwiftCode,
    handleSearchSwiftCode,
    setSwiftCodeForeign,
    setSwiftMediatorCodeForeign,
    handleChangeBudgetClassCode,
    classCodeBudget,
    dataGetOrganization,
    dataGetClassification,
    submitFormConversion,
    handleSubmitConversion,
    handleSwitchTaxEnabled,
    taxEnabledLocal,
    submitFormLocalTransfer,
    sendTransferTypeMutation,
    checkLeave,
    setCheckLeave,
    handleLeavePage,
    pageName,
    dataSwiftCode,
    setSelectedFromAccountTrigger,
    getValues,
    ibanField,
    handleChangeAmount,
    amountValue,
    handleChangeInvoiceNo,
    invoiceValue,
    budgetIban,
    valueTextArea,
    handleChangeTextArea,
    commissionOption,
    individualRates,
    handleChangeIndividualRate,
    voenEdv,
    beneficiarNameEdv,
    handleChangeVoenEdv,
    handleChangeBeneficiarNameEdv,
    innForeign,
    kppForeign,
    beneficiarNameForeign,
    beneficiarAddressForeign,
    handleChangeInnForeign,
    handleChangeKppForeign,
    handleChangeBeneficiarNameForeign,
    handleChangeBeneficiarAddressForeign,
    voenLocal,
    beneficiarIbanLocal,
    beneficiarNameLocal,
    handleChangeBeneficiarIbanLocal,
    handleChangeVoenLocal,
    handleChangeBeneficiarNameLocal,
    contractNumberRequiredInBank,
    handleSaveTemplate,
    handleChangeTemplateName,
    pathUrl,
    navigate,
    dataCreateTemplate,
    saveTemplateSuccess,
    setSaveTemplateSuccess,
    handleEditTemplate,
    templateData,
    templateName,
    showTemplateBtn,
    setTemplateName,
    errorSaveTemplate,
    setErrorSaveTemplate,
    formId,
  };
};

export default useTransferPage;
